import React, { Component } from "react";
import { renderToString } from 'react-dom/server'
import { Row, Col, Button, Form, Modal, Toast, Card } from "react-bootstrap";
import { withStyles } from "@material-ui/core/styles";
import sha256 from "sha256";
// import SplitPane from "react-split-pane";
import { INVOICE_SECTIONS, RESIZE_DIRECTIONS } from "../../lib/config/enums";
import Ruler from "../../lib/plugins/ruler/Ruler";
import {
  createElement,
  createImageElement,
  companyPath,
  formatDate,
} from "../../lib/global/helpers";
import Split from 'react-split-it';
import Properties from "./new/properties";
import Head from "./new/head";
import Items from "./new/items";
import Total from "./new/total";
import Foot from "./new/foot";
import HTMLTemplate from "./HTMLTemplate";
import TemplateElement from "./TemplateElement";
import { GetSchema, SaveTemplate } from "../../lib/api/data/Request";
import InvoicePreview from './InvoicePreview';

import { connect } from "react-redux";
import {
  updateProp,
  updateHead,
  updateItems,
  updateTotal,
  updateFoot,
  setSelectedElement,
  moveElement,
  resizeElement,
  setSectionHeight,
  removeHeaderImage,
  updateHeaderLogo,
  updateSplitSizes,
  updateElementStyle
} from "../../../redux/actions/TemplateActions";

import { library } from "@fortawesome/fontawesome-svg-core";
import * as Icons from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import HTMLHeaderTemplate from "./HTMLHeaderTemplate";
import HTMLFooterTemplate from "./HTMLFooterTemplate";
import HTMLTotalTemplate from "./HTMLTotalTemplate";

const iconList = Object.keys(Icons)
  .filter((key) => key !== "fas" && key !== "prefix")
  .map((icon) => Icons[icon]);

library.add(...iconList);

class NewTemplate extends Component {
  constructor(props) {
    super(props);

    //  console.log(this.props.properties);
    this.canvesWrapper = React.createRef();
    this.canves = React.createRef();

    this.headerContent = React.createRef();
    this.bodyContent = React.createRef();
    this.footerContent = React.createRef();

    // this.selectedElementResizeOn = false;
    // this.selectedElementMoveOn = false;

    this.elementRefs = new Map();
    this._elementRefs = {};
    this._elementDimensions = {};

    this.state = {
      selectedElementName: "",
      wrapper: {
        height: 0,
        width: 0,
      },
      showPageGridLines: false,
      showGridLines: true,
      showPointer: false,
      selectedSection: INVOICE_SECTIONS.PROPS,
      attributes: null,

      measureSpec: {},
      showAlert: false,
      showToolTips: false,
      showSaveConfirm: false,
      isSaving: false,
      isSaved: false,
      successMessage: "",
      errorMessage: "",
      splitSizes: [0.25, 0.55, 0.1, 0.1],
      tempLogo: null,
      selectedElementResizeOn: false,
      selectedElementMoveOn: false,
      activeStyles: {},
      manuallyPositionedElements: new Set(),
    };

    this._setSelectedSection = this._setSelectedSection.bind(this);
    this._slideMouseDown = this._slideMouseDown.bind(this);
    this._slideMouseMove = this._slideMouseMove.bind(this);
    this._slideMouseUp = this._slideMouseUp.bind(this);
    this._selectElementFromChild = this._selectElementFromChild.bind(this);
    this._renderCompanyElements = this._renderCompanyElements.bind(this);
    this._renderVatSummary = this._renderVatSummary.bind(this);
    this.editIcons = {
      bold: {
        title: "Bold",
        property: "fontWeight",
        value: "bold",
        icon: "type-bold",
        isToggle: true
      },

      italic: {
        title: "Italic",
        property: "fontStyle",
        value: "italic",
        icon: "type-italic",
        isToggle: true
      },

      strikethrough: {
        title: "Strikethrough",
        property: "textDecoration",
        value: "line-through",
        icon: "type-strikethrough",
        isToggle: true
      },

      underline: {
        title: "Underline",
        property: "textDecoration",
        value: "underline",
        icon: "type-underline",
        isToggle: true
      },

      h1: {
        title: "Header 1",
        property: "heading",
        value: "h1",
        icon: "type-h1",
        isHeading: true,
        isToggle: true,
        offValue: "normal"
      },

      h2: {
        title: "Header 2",
        property: "heading",
        value: "h2",
        icon: "type-h2",
        isHeading: true,
        isToggle: true,
        offValue: "normal"
      },

      h3: {
        title: "Header 3",
        property: "heading",
        value: "h3",
        icon: "type-h3",
        isHeading: true,
        isToggle: true,
        offValue: "normal"
      },

      alignStart: {
        title: "Align Start",
        property: "textAlign",
        value: "left",
        icon: "align-start",
        isToggle: true
      },

      alignCenter: {
        title: "Align Center",
        property: "textAlign",
        value: "center",
        icon: "align-center",
        isToggle: true
      },

      alignEnd: {
        title: "Align End",
        property: "textAlign",
        value: "right",
        icon: "align-end",
        isToggle: true
      },

      listBullet: {
        title: "Bullet List",
        property: "listStyleType",
        value: "disc",
        icon: "list-ul",
        isToggle: true,
        offValue: "none",
        isList: true
      },

      listNumbered: {
        title: "Numbered List",
        property: "listStyleType",
        value: "decimal",
        icon: "list-ol",
        isToggle: true,
        offValue: "none",
        isList: true
      },

      fontSizePlus: {
        title: "Increase font size",
        property: "fontSize",
        value: +1,
        icon: "plus",
        isIncrement: true,
      },

      fontSizeMinus: {
        title: "Decrease font size",
        property: "fontSize",
        value: -1,
        icon: "dash",
        isIncrement: true,
      },
    };
  }

  _debugElementRefs = () => {
    console.log("=== DEBUG ELEMENT REFS ===");
    console.log("elementRefs Map size:", this.elementRefs.size);
    console.log("_elementRefs object keys:", Object.keys(this._elementRefs));
    console.log("_elementDimensions keys:", Object.keys(this._elementDimensions || {}));

    const companyPropsCount = this.props.properties.head.companyProps
      ? Object.keys(this.props.properties.head.companyProps).filter(key =>
        this.props.properties.head.companyProps[key]?.show
      ).length
      : 0;

    console.log("=== ELEMENT COUNTS ===");
    console.log("Regular elements in head:", Object.keys(this.props.properties.head.elements || {}).length);
    console.log("Company props (shown):", companyPropsCount);
    console.log("Total elements in total:", Object.keys(this.props.properties.total.elements || {}).length);
    console.log("Total elements in foot:", Object.keys(this.props.properties.foot.elements || {}).length);

    this.elementRefs.forEach((element, id) => {
      console.log(`Element ${id}:`, element);
    });
  };

  _registerElementRef = (elementId, domElement) => {
    if (domElement) {
      this.elementRefs.set(elementId, domElement);
      this._elementRefs[elementId] = domElement;

      if (!this._elementDimensions) {
        this._elementDimensions = {};
      }

      const rect = domElement.getBoundingClientRect();
      this._elementDimensions[elementId] = {
        width: rect.width,
        height: rect.height,
        top: rect.top,
        left: rect.left,
        offsetWidth: domElement.offsetWidth,
        offsetHeight: domElement.offsetHeight
      };

      console.log(`Registered element: ${elementId}`, this._elementDimensions[elementId]);
    }
  };

  _unregisterElementRef = (elementId) => {
    this.elementRefs.delete(elementId);
    delete this._elementRefs[elementId];
    delete this._elementDimensions[elementId];
  };

  _getElementById = (id) => {
    return this.elementRefs.get(id) || this._elementRefs[id];
  };


  _getElementDimensions = (elementId) => {
    const domElement = this._getElementById(elementId);

    if (domElement) {
      const rect = domElement.getBoundingClientRect();
      const style = window.getComputedStyle(domElement);

      return {
        width: rect.width,
        height: rect.height,
        top: parseInt(style.top) || 0,
        left: parseInt(style.left) || 0
      };
    }

    const element = this._findElementInProps(elementId);
    if (element) {
      return {
        width: parseInt(element.style?.width) || 100,
        height: parseInt(element.style?.height) || 50,
        top: parseInt(element.style?.top) || 0,
        left: parseInt(element.style?.left) || 0
      };
    }

    return { width: 100, height: 50, top: 0, left: 0 };
  };

  _getElementDimensionsFromDOM = (elementId) => {
    const domElement = this._getElementById(elementId);

    if (domElement) {
      const rect = domElement.getBoundingClientRect();
      const computedStyle = window.getComputedStyle(domElement);

      let elementHeight = rect.height;
      const elementWidth = rect.width;

      if (computedStyle.whiteSpace === 'pre-line' ||
        domElement.tagName === 'TEXTAREA' ||
        domElement.querySelector('textarea')) {
        const lineHeight = parseInt(computedStyle.lineHeight) || 16;
        const element = this._findElementInProps(elementId);
        if (element && element.text) {
          const lineCount = element.text.split('\n').length;
          elementHeight = Math.max(elementHeight, lineCount * lineHeight + 10);
        }
      }

      return {
        width: elementWidth,
        height: elementHeight,
        top: parseInt(computedStyle.top) || 0,
        left: parseInt(computedStyle.left) || 0
      };
    }

    return { width: 150, height: 30, top: 0, left: 0 };
  };
  _autoReorganizeElements = () => {
    const manuallyPositionedElements = this.state.manuallyPositionedElements;

    const newElements = [];

    if (this.props.properties.head.elements) {
      Object.keys(this.props.properties.head.elements).forEach(key => {
        const element = this.props.properties.head.elements[key];
        if (!manuallyPositionedElements.has(element.id)) {
          const hasDefaultPosition = element.style &&
            (element.style.top === "40px" || element.style.left === "40px" ||
              !element.style.top || !element.style.left);

          if (hasDefaultPosition) {
            const dimensions = this._getElementDimensionsFromDOM(element.id);
            newElements.push({
              key,
              element: {
                ...element,
                style: {
                  ...element.style,
                  width: dimensions.width + "px",
                  height: dimensions.height + "px",
                  top: dimensions.top + "px",
                  left: dimensions.left + "px"
                }
              },
              isCompanyProp: false,
              dimensions
            });
          }
        }
      });
    }

    if (this.props.properties.head.companyProps) {
      Object.keys(this.props.properties.head.companyProps).forEach(key => {
        const prop = this.props.properties.head.companyProps[key];
        if (prop.show && !manuallyPositionedElements.has(prop.id)) {
          const hasDefaultPosition = prop.style &&
            (prop.style.top === "40px" || prop.style.left === "40px" ||
              !prop.style.top || !prop.style.left);

          if (hasDefaultPosition) {
            const dimensions = this._getElementDimensionsFromDOM(prop.id);
            newElements.push({
              key,
              element: {
                ...prop,
                style: {
                  ...prop.style,
                  width: dimensions.width + "px",
                  height: dimensions.height + "px",
                  top: dimensions.top + "px",
                  left: dimensions.left + "px"
                }
              },
              isCompanyProp: true,
              dimensions
            });
          }
        }
      });
    }

    if (newElements.length === 0) {
      console.log("No new elements to auto-arrange");
      return;
    }

    setTimeout(() => {
      this._reorganizeOnlyNewElements(newElements, manuallyPositionedElements);
    }, 100);
  };

  _reorganizeOnlyNewElements = (newElements, manuallyPositionedElements) => {
    const reorganized = {};
    const reorganizedCompanyProps = { ...this.props.properties.head.companyProps };

    const fixedElements = [];

    if (this.props.properties.head.elements) {
      Object.keys(this.props.properties.head.elements).forEach(key => {
        const element = this.props.properties.head.elements[key];
        if (manuallyPositionedElements.has(element.id)) {
          fixedElements.push(element);
        }
      });
    }

    if (this.props.properties.head.companyProps) {
      Object.keys(this.props.properties.head.companyProps).forEach(key => {
        const prop = this.props.properties.head.companyProps[key];
        if (prop.show && manuallyPositionedElements.has(prop.id)) {
          fixedElements.push(prop);
        }
      });
    }

    const START_X = 40;
    const START_Y = 40;
    const MAX_X = 800;
    const MAX_Y = 400;
    const MARGIN = 10;
    const ELEMENTS_PER_COLUMN = 5;
    const COLUMN_WIDTH = 200;

    const columns = [];

    fixedElements.forEach(element => {
      if (!element.style) return;

      const elementLeft = parseInt(element.style.left) || 0;
      const elementTop = parseInt(element.style.top) || 0;
      const elementWidth = parseInt(element.style.width) || 150;
      const elementHeight = parseInt(element.style.height) || 30;

      let columnIndex = Math.floor((elementLeft - START_X) / COLUMN_WIDTH);
      if (columnIndex < 0) columnIndex = 0;

      if (!columns[columnIndex]) {
        columns[columnIndex] = [];
      }

      columns[columnIndex].push({
        element: element,
        top: elementTop,
        left: elementLeft,
        right: elementLeft + elementWidth,
        bottom: elementTop + elementHeight,
        width: elementWidth,
        height: elementHeight
      });
    });

    columns.forEach(column => {
      column.sort((a, b) => a.top - b.top);
    });

    const sortedNewElements = [...newElements].sort((a, b) => {
      const aHeight = a.dimensions?.height || 30;
      const bHeight = b.dimensions?.height || 30;
      return bHeight - aHeight;
    });

    sortedNewElements.forEach(({ key, element, isCompanyProp, dimensions }) => {
      const elementWidth = dimensions?.width || 150;
      const elementHeight = dimensions?.height || 30;

      let placed = false;

      for (let columnIndex = 0; columnIndex <= columns.length; columnIndex++) {
        const columnElements = columns[columnIndex] || [];
        const columnX = START_X + (columnIndex * COLUMN_WIDTH);

        if (columnX + elementWidth > MAX_X) continue;

        if (columnIndex === columns.length) {
          if (!columns[columnIndex]) {
            columns[columnIndex] = [];
          }

          const updatedElement = {
            ...element,
            style: {
              ...element.style,
              top: START_Y + "px",
              left: columnX + "px"
            }
          };

          if (isCompanyProp) {
            reorganizedCompanyProps[key] = {
              ...reorganizedCompanyProps[key],
              style: updatedElement.style
            };
          } else {
            reorganized[key] = updatedElement;
          }

          columns[columnIndex].push({
            element: updatedElement,
            top: START_Y,
            left: columnX,
            right: columnX + elementWidth,
            bottom: START_Y + elementHeight,
            width: elementWidth,
            height: elementHeight
          });

          placed = true;
          break;
        }

        if (columnElements.length < ELEMENTS_PER_COLUMN) {
          let positionY = START_Y;
          let foundGap = false;

          if (columnElements.length === 0) {
            positionY = START_Y;
            foundGap = true;
          } else {
            if (START_Y + elementHeight + MARGIN <= columnElements[0].top) {
              positionY = START_Y;
              foundGap = true;
            } else {
              for (let i = 0; i < columnElements.length - 1; i++) {
                const current = columnElements[i];
                const next = columnElements[i + 1];
                const testY = current.bottom + MARGIN;

                if (testY + elementHeight + MARGIN <= next.top) {
                  positionY = testY;
                  foundGap = true;
                  break;
                }
              }

              if (!foundGap) {
                const lastElement = columnElements[columnElements.length - 1];
                const testY = lastElement.bottom + MARGIN;

                if (testY + elementHeight <= MAX_Y) {
                  positionY = testY;
                  foundGap = true;
                }
              }
            }
          }

          if (foundGap) {
            const updatedElement = {
              ...element,
              style: {
                ...element.style,
                top: positionY + "px",
                left: columnX + "px"
              }
            };

            if (isCompanyProp) {
              reorganizedCompanyProps[key] = {
                ...reorganizedCompanyProps[key],
                style: updatedElement.style
              };
            } else {
              reorganized[key] = updatedElement;
            }

            columnElements.push({
              element: updatedElement,
              top: positionY,
              left: columnX,
              right: columnX + elementWidth,
              bottom: positionY + elementHeight,
              width: elementWidth,
              height: elementHeight
            });

            columnElements.sort((a, b) => a.top - b.top);

            placed = true;
            break;
          }
        }
      }

      if (!placed) {
        console.warn("Could not place element in columns, scanning for any available space");

        for (let y = START_Y; y <= MAX_Y - elementHeight; y += MARGIN) {
          for (let x = START_X; x <= MAX_X - elementWidth; x += MARGIN) {
            const testRect = {
              top: y,
              left: x,
              right: x + elementWidth,
              bottom: y + elementHeight
            };

            let hasOverlap = false;

            for (const element of fixedElements) {
              if (!element.style) continue;

              const elementTop = parseInt(element.style.top) || 0;
              const elementLeft = parseInt(element.style.left) || 0;
              const elementWidth = parseInt(element.style.width) || 150;
              const elementHeight = parseInt(element.style.height) || 30;

              const elementRect = {
                top: elementTop,
                left: elementLeft,
                right: elementLeft + elementWidth,
                bottom: elementTop + elementHeight
              };

              if (this._checkRectOverlap(testRect, elementRect, MARGIN)) {
                hasOverlap = true;
                break;
              }
            }

            if (!hasOverlap) {
              for (const col of columns) {
                for (const placed of col) {
                  const placedRect = {
                    top: placed.top,
                    left: placed.left,
                    right: placed.right,
                    bottom: placed.bottom
                  };

                  if (this._checkRectOverlap(testRect, placedRect, MARGIN)) {
                    hasOverlap = true;
                    break;
                  }
                }
                if (hasOverlap) break;
              }
            }

            if (!hasOverlap) {
              const updatedElement = {
                ...element,
                style: {
                  ...element.style,
                  top: y + "px",
                  left: x + "px"
                }
              };

              if (isCompanyProp) {
                reorganizedCompanyProps[key] = {
                  ...reorganizedCompanyProps[key],
                  style: updatedElement.style
                };
              } else {
                reorganized[key] = updatedElement;
              }

              const columnIndex = Math.floor((x - START_X) / COLUMN_WIDTH);
              if (!columns[columnIndex]) {
                columns[columnIndex] = [];
              }

              columns[columnIndex].push({
                element: updatedElement,
                top: y,
                left: x,
                right: x + elementWidth,
                bottom: y + elementHeight,
                width: elementWidth,
                height: elementHeight
              });

              columns[columnIndex].sort((a, b) => a.top - b.top);

              placed = true;
              break;
            }
          }
          if (placed) break;
        }
      }

      if (!placed) {
        console.error("No space found for element, placing at default position");
        const fallbackX = START_X;
        const fallbackY = START_Y;

        const updatedElement = {
          ...element,
          style: {
            ...element.style,
            top: fallbackY + "px",
            left: fallbackX + "px"
          }
        };

        if (isCompanyProp) {
          reorganizedCompanyProps[key] = {
            ...reorganizedCompanyProps[key],
            style: updatedElement.style
          };
        } else {
          reorganized[key] = updatedElement;
        }
      }
    });

    const updatedHead = {
      ...this.props.properties.head,
      elements: {
        ...this.props.properties.head.elements,
        ...reorganized
      },
      companyProps: reorganizedCompanyProps
    };

    this.props.updateHead(updatedHead);
  }
  _reorganizeWithLayout = (allElements, elementIds) => {
    const reorganized = {};
    const reorganizedCompanyProps = { ...this.props.properties.head.companyProps };
    const placedElements = [];

    const ITEMS_PER_COLUMN = 4;
    const COLUMN_WIDTH = 200;
    const START_TOP = 40;
    const START_LEFT = 40;
    const VERTICAL_SPACING = 20;
    const HORIZONTAL_SPACING = 30;

    let currentTop = START_TOP;
    let currentLeft = START_LEFT;
    let itemsInCurrentColumn = 0;

    elementIds.forEach((elementId, index) => {
      let elementKey = null;
      let element = null;

      for (const key in allElements) {
        if (allElements[key].id === elementId) {
          elementKey = key;
          element = allElements[key];
          break;
        }
      }

      if (!element) return;

      const elementRef = this._getElementById(element.id);
      let elementWidth = 100;
      let elementHeight = 30;

      if (elementRef) {
        const rect = elementRef.getBoundingClientRect();
        elementWidth = rect.width;
        elementHeight = rect.height;
      }

      console.log(`Positioning ${elementKey} (${elementWidth}x${elementHeight})`);

      if (itemsInCurrentColumn >= ITEMS_PER_COLUMN) {
        currentLeft += COLUMN_WIDTH + HORIZONTAL_SPACING;
        currentTop = START_TOP;
        itemsInCurrentColumn = 0;
      }

      let positionFound = false;
      let verticalOffset = 0;

      while (!positionFound && verticalOffset < 1000) {
        positionFound = true;
        const testTop = currentTop + verticalOffset;

        const testElement = {
          id: element.id,
          style: {
            top: testTop + "px",
            left: currentLeft + "px",
            width: elementWidth + "px",
            height: elementHeight + "px"
          }
        };

        for (const placed of placedElements) {
          if (this._checkElementOverlap(testElement, placed)) {
            positionFound = false;
            verticalOffset += 5;
            break;
          }
        }

        if (positionFound) {
          currentTop = testTop;
        }
      }

      const updatedElement = {
        ...element,
        style: {
          ...element.style,
          top: currentTop + "px",
          left: currentLeft + "px"
        }
      };

      const isCompanyProp = this.props.properties.head.companyProps &&
        this.props.properties.head.companyProps[elementKey];

      if (isCompanyProp) {
        reorganizedCompanyProps[elementKey] = {
          ...reorganizedCompanyProps[elementKey],
          style: updatedElement.style
        };
      } else {
        reorganized[elementKey] = updatedElement;
      }

      placedElements.push({
        id: element.id,
        style: {
          top: currentTop + "px",
          left: currentLeft + "px",
          width: elementWidth + "px",
          height: elementHeight + "px"
        }
      });

      currentTop += elementHeight + VERTICAL_SPACING;
      itemsInCurrentColumn++;

      console.log(`Placed ${elementKey} at (${currentTop - elementHeight - VERTICAL_SPACING}, ${currentLeft})`);
    });

    const updatedHead = {
      ...this.props.properties.head,
      elements: reorganized,
      companyProps: reorganizedCompanyProps
    };

    this.props.updateHead(updatedHead);
    console.log(`Auto-reorganization complete! Placed ${elementIds.length} elements`);
  };

  _autoReorganizeTotalElements = () => {
    console.log("Auto-reorganizing Total elements...");

    const allElements = {};
    const elementIds = [];

    if (this.props.properties.total.elements) {
      Object.keys(this.props.properties.total.elements).forEach(key => {
        allElements[key] = this.props.properties.total.elements[key];
        elementIds.push(this.props.properties.total.elements[key].id);
      });
    }

    if (this.props.properties.total.VatSummary &&
      Object.keys(this.props.properties.total.VatSummary).length > 0) {
      allElements['VatSummary'] = this.props.properties.total.VatSummary;
      elementIds.push(this.props.properties.total.VatSummary.id);
    }

    if (elementIds.length === 0) return;

    setTimeout(() => {
      const missingRefs = elementIds.filter(id => !this._getElementById(id));
      if (missingRefs.length > 0) {
        setTimeout(() => this._autoReorganizeTotalElements(), 100);
        return;
      }

      this._reorganizeTotalWithLayout(allElements, elementIds);
    }, 100);
  };

  _reorganizeTotalWithLayout = (allElements, elementIds) => {
    const reorganized = {};

    const ITEMS_PER_COLUMN = 2;
    const COLUMN_WIDTH = 180;
    const START_X = 40;
    const START_Y = 40;
    const ROW_HEIGHT = 35;
    const COLUMN_SPACING = 30;

    let currentColumn = 0;
    let currentRow = 0;

    elementIds.forEach((elementId, index) => {
      let elementKey = null;
      let element = null;

      for (const key in allElements) {
        if (allElements[key].id === elementId) {
          elementKey = key;
          element = allElements[key];
          break;
        }
      }

      if (!element) return;

      const column = Math.floor(index / ITEMS_PER_COLUMN);
      const row = index % ITEMS_PER_COLUMN;

      const x = START_X + (column * (COLUMN_WIDTH + COLUMN_SPACING));
      const y = START_Y + (row * ROW_HEIGHT);

      const updatedElement = {
        ...element,
        style: {
          ...element.style,
          top: `${y}px`,
          left: `${x}px`
        }
      };

      reorganized[elementKey] = updatedElement;
    });

    const updatedTotal = {
      ...this.props.properties.total
    };

    const updatedElements = {};
    Object.keys(reorganized).forEach(key => {
      if (key === 'VatSummary') {
        updatedTotal.VatSummary = reorganized[key];
      } else {
        updatedElements[key] = reorganized[key];
      }
    });

    updatedTotal.elements = updatedElements;

    this.props.updateTotal(updatedTotal);
    console.log(`Auto-reorganization of Total complete!`);
  };

  _autoReorganizeFootElements = () => {
    console.log("Auto-reorganizing Foot elements...");

    const allElements = {};
    const elementIds = [];

    if (this.props.properties.foot.elements) {
      Object.keys(this.props.properties.foot.elements).forEach(key => {
        allElements[key] = this.props.properties.foot.elements[key];
        elementIds.push(this.props.properties.foot.elements[key].id);
      });
    }

    if (elementIds.length === 0) return;

    setTimeout(() => {
      const missingRefs = elementIds.filter(id => !this._getElementById(id));
      if (missingRefs.length > 0) {
        setTimeout(() => this._autoReorganizeFootElements(), 100);
        return;
      }

      this._reorganizeFootWithLayout(allElements, elementIds);
    }, 100);
  };

  _reorganizeFootWithLayout = (allElements, elementIds) => {
    const reorganized = {};

    const ITEMS_PER_ROW = 3;
    const ITEM_WIDTH = 200;
    const START_X = 40;
    const START_Y = 20;
    const HORIZONTAL_SPACING = 20;
    const VERTICAL_SPACING = 30;

    elementIds.forEach((elementId, index) => {
      let elementKey = null;
      let element = null;

      for (const key in allElements) {
        if (allElements[key].id === elementId) {
          elementKey = key;
          element = allElements[key];
          break;
        }
      }

      if (!element) return;

      const row = Math.floor(index / ITEMS_PER_ROW);
      const col = index % ITEMS_PER_ROW;

      const x = START_X + (col * (ITEM_WIDTH + HORIZONTAL_SPACING));
      const y = START_Y + (row * VERTICAL_SPACING);

      const updatedElement = {
        ...element,
        style: {
          ...element.style,
          top: `${y}px`,
          left: `${x}px`
        }
      };

      reorganized[elementKey] = updatedElement;
    });

    const updatedFoot = {
      ...this.props.properties.foot,
      elements: reorganized
    };

    this.props.updateFoot(updatedFoot);
    console.log(`Auto-reorganization of Footer complete!`);
  };

  _findElementInProps = (elementId) => {
    const sections = ['head', 'total', 'foot'];

    for (const section of sections) {
      const elements = this.props.properties[section]?.elements || {};
      for (const key in elements) {
        if (elements[key].id === elementId) {
          return elements[key];
        }
      }

      if (section === 'head' && this.props.properties.head.companyProps) {
        const companyProps = this.props.properties.head.companyProps;
        for (const key in companyProps) {
          if (companyProps[key].id === elementId) {
            return companyProps[key];
          }
        }
      }
    }

    return null;
  };

  _checkElementOverlap = (element1, element2) => {
    if (!element1 || !element2) return false;

    const dim1 = this._getElementDimensions(element1.id || element1);
    const dim2 = this._getElementDimensions(element2.id || element2);

    console.log(`Checking overlap: Element1 at (${dim1.left}, ${dim1.top}) [${dim1.width}x${dim1.height}] vs Element2 at (${dim2.left}, ${dim2.top}) [${dim2.width}x${dim2.height}]`);

    const margin = 5;

    const overlap = !(
      dim1.left + dim1.width + margin < dim2.left ||
      dim2.left + dim2.width + margin < dim1.left ||
      dim1.top + dim1.height + margin < dim2.top ||
      dim2.top + dim2.height + margin < dim1.top
    );

    if (overlap) {
      console.log("OVERLAP DETECTED!");
    }

    return overlap;
  };

  _reorganizeElements = () => {
    const allElements = {};

    if (this.props.properties.head.elements) {
      Object.assign(allElements, this.props.properties.head.elements);
    }

    if (this.props.properties.head.companyProps) {
      Object.keys(this.props.properties.head.companyProps).forEach(key => {
        const prop = this.props.properties.head.companyProps[key];
        if (prop.show) {
          allElements[key] = prop;
        }
      });
    }

    const elementKeys = Object.keys(allElements);
    console.log(`Found ${elementKeys.length} total elements to reorganize (including company props)`);

    if (elementKeys.length === 0) {
      console.log("No elements to reorganize");
      return;
    }

    if (this.elementRefs.size === 0 && Object.keys(this._elementRefs).length === 0) {
      console.log("No element refs available yet. Elements might not be mounted.");

      setTimeout(() => {
        console.log("Retrying after delay...");
        this._reorganizeElements();
      }, 1000);
      return;
    }

    console.log("Element refs available:", this.elementRefs.size);

    setTimeout(() => {
      const reorganized = {};
      const reorganizedCompanyProps = { ...this.props.properties.head.companyProps };
      const placedElements = [];

      const offsetPx = 30;
      const columnWidth = 200;
      const maxRowsPerColumn = 10;
      const maxColumns = 3;

      let currentTop = 40;
      let currentLeft = 40;
      let columnIndex = 0;
      let rowIndex = 0;

      elementKeys.forEach((key, index) => {
        const element = allElements[key];

        const elementRef = this._getElementById(element.id);
        let elementWidth = 100;
        let elementHeight = 50;

        if (elementRef) {
          const rect = elementRef.getBoundingClientRect();
          elementWidth = rect.width;
          elementHeight = rect.height;
        }

        console.log(`Element ${key} (${element.id}): ${elementWidth}x${elementHeight}`);

        let positionFound = false;
        let attempts = 0;
        const maxAttempts = 100;

        while (!positionFound && attempts < maxAttempts) {
          positionFound = true;

          for (const placed of placedElements) {
            const testElement = {
              id: element.id,
              style: {
                top: currentTop + "px",
                left: currentLeft + "px",
                width: elementWidth + "px",
                height: elementHeight + "px"
              }
            };

            if (this._checkElementOverlap(testElement, placed)) {
              positionFound = false;

              currentTop += offsetPx;
              rowIndex++;

              if (rowIndex >= maxRowsPerColumn) {
                currentTop = 40;
                currentLeft += columnWidth;
                rowIndex = 0;
                columnIndex++;

                if (columnIndex >= maxColumns) {
                  currentLeft = 40;
                  currentTop += offsetPx * 20;
                  columnIndex = 0;
                  rowIndex = 0;
                }
              }

              break;
            }
          }

          attempts++;
          if (attempts >= maxAttempts) {
            console.warn(`Force placing element ${key} at (${currentTop}, ${currentLeft})`);
            positionFound = true;
          }
        }

        const updatedElement = {
          ...element,
          style: {
            ...element.style,
            top: currentTop + "px",
            left: currentLeft + "px"
          }
        };

        if (this.props.properties.head.companyProps &&
          this.props.properties.head.companyProps[key]) {
          reorganizedCompanyProps[key] = {
            ...reorganizedCompanyProps[key],
            style: updatedElement.style
          };
        } else {
          reorganized[key] = updatedElement;
        }

        placedElements.push({
          id: element.id,
          style: {
            top: currentTop + "px",
            left: currentLeft + "px",
            width: elementWidth + "px",
            height: elementHeight + "px"
          }
        });

        console.log(`Placed element ${key} at (${currentTop}, ${currentLeft})`);

        currentTop += elementHeight + offsetPx;
        rowIndex++;

        if (rowIndex >= maxRowsPerColumn) {
          currentTop = 40;
          currentLeft += columnWidth;
          rowIndex = 0;
          columnIndex++;

          if (columnIndex >= maxColumns) {
            currentLeft = 40;
            currentTop += offsetPx * 20;
            columnIndex = 0;
            rowIndex = 0;
          }
        }
      });

      const properties = {
        ...this.props.properties.head,
        elements: reorganized,
        companyProps: reorganizedCompanyProps
      };

      this.props.updateHead(properties);

      console.log("Reorganization complete!");

    }, 500);
  };
  _setColumnTextAlign = () => {
    const items = this.props.properties.items.items;
    let needsUpdate = false;
    const updatedItems = { ...items };

    Object.keys(updatedItems).forEach(key => {
      if (updatedItems[key] && !updatedItems[key].textAlign) {
        updatedItems[key] = {
          ...updatedItems[key],
          textAlign: 'left'
        };
        needsUpdate = true;
      }
    });

    if (needsUpdate) {
      const updatedItemsSection = {
        ...this.props.properties.items,
        items: updatedItems
      };
      this.props.updateItems(updatedItemsSection);
    }
  };
  componentDidMount() {
    GetSchema().then((response) => {
      if (response.isSuccess)
        this.setState(
          {
            attributes: response.data.Result,
          },
          function (e) {
            if (
              Object.keys(this.props.properties.head.companyProps).length === 0
            ) {
              var ele = [];
              for (const prop in this.state.attributes[companyPath()]
                .Properties) {
                var element = createElement(companyPath() + "." + prop);
                ele[prop] = {
                  show: false,
                  name: element.name,
                  text: element.text,
                  style: element.style,
                  data: element.data,
                  id: element.id,
                };
              }

              var properties = {
                ...this.props.properties.head,
                companyProps: ele,
              };
              this.props.updateHead(properties);

              setTimeout(() => {
                this._autoReorganizeElements();
                this._autoReorganizeTotalElements();
                this._autoReorganizeFootElements();
              }, 500);
            }
          }
        );
      else {
        this.setState({ errorMessage: response.message });
      }
    });

    this._setColumnTextAlign();

    let totalheight = this.props.heights.head + this.props.heights.body + this.props.heights.total + this.props.heights.foot
    this.setState({
      isEdited: false,
      wrapper: {
        height: this.canvesWrapper.offsetHeight,
        width: this.canvesWrapper.offsetWidth,
      },

      sliderHeadMousedown: false,
      sliderBodyMouseDown: false,
      sliderTotalMouseDown: false,
      splitSizes: [this.props.heights.head / totalheight, this.props.heights.body / totalheight, this.props.heights.total / totalheight, this.props.heights.foot / totalheight]
    });
  }



  _setMeasureSpec = (value) => {
    this.setState({ measureSpec: value });
  };

  _changeProprtyProp = function (name, obj) {
    this.setState(
      {
        properties: {
          ...this.props.properties,
          [name]: obj,
        },
        isEdited: true,
      },
      function () {
        //console.log(name, obj, this.props.properties);
      }
    );
  };

  _selectElementFromChild = function (id) {
    var ele = document.getElementById(id);
    ele.click();
  };

  _setSelectedSection(obj) {
    this.setState({ selectedSection: obj });
  }

  _slideMouseDown = function (e, obj) {
    if (obj == "head")
      this.setState({
        sliderHeadMousedown: true,
        sliderBodyMouseDown: false,
        sliderTotalMouseDown: false,
      });
    else if (obj == "body")
      this.setState({
        sliderHeadMousedown: false,
        sliderBodyMouseDown: true,
        sliderTotalMouseDown: false,
      });
    else if (obj == "total")
      this.setState({
        sliderHeadMousedown: false,
        sliderBodyMouseDown: false,
        sliderTotalMouseDown: true,
      });
  };

  _slideMouseMove = function (e) {
    if (
      this.state.sliderHeadMousedown ||
      this.state.sliderBodyMouseDown ||
      this.state.sliderTotalMouseDown
    ) {
      let currentTargetRect = this.canves.getBoundingClientRect();
      var arrowY = e.clientY - currentTargetRect.top;

      var height = (arrowY / this.canves.offsetHeight) * 100;
      height = height < 0 ? 0 : height;

      var head_h = this.props.heights.head;
      var body_h = this.props.heights.body;
      var totl_h = this.props.heights.total;
      var foot_h = this.props.heights.foot;

      var head_new_h = head_h;
      var body_new_h = body_h;
      var totl_new_h = totl_h;
      var foot_new_h = foot_h;
      var diff = 0;

      //console.log(this.canves.offset);

      if (this.state.sliderHeadMousedown) {
        diff = height - head_h;
        head_new_h = height;
        body_new_h = body_h - diff;
      } else if (this.state.sliderBodyMouseDown) {
        height -= head_h;
        diff = height - body_h;
        body_new_h = height;
        totl_new_h = totl_h - diff;
      } else if (this.state.sliderTotalMouseDown) {
        height -= body_h + head_h;
        diff = height - totl_h;
        totl_new_h = height;
        foot_new_h = foot_h - diff;
      }

      this.props.setSectionHeight(
        head_new_h,
        body_new_h,
        totl_new_h,
        foot_new_h
      );
    }
  };

  _slideMouseUp = function (e) {
    this.setState({
      sliderHeadMousedown: false,
      sliderBodyMouseDown: false,
      sliderTotalMouseDown: false,
    });
  };

  _updateActiveStyles = (element) => {
    if (!element || !element.style) {
      this.setState({ activeStyles: {} });
      return;
    }

    const activeStyles = {};
    const { style } = element;

    activeStyles.bold = style.fontWeight === "bold";

    activeStyles.italic = style.fontStyle === "italic";

    activeStyles.underline = style.textDecoration === "underline";

    activeStyles.strikethrough = style.textDecoration === "line-through";

    if (style.textAlign === "left") activeStyles.alignStart = true;
    if (style.textAlign === "center") activeStyles.alignCenter = true;
    if (style.textAlign === "right") activeStyles.alignEnd = true;

    if (style.listStyleType === "disc") activeStyles.listBullet = true;
    if (style.listStyleType === "decimal") activeStyles.listNumbered = true;

    if (style.fontSize === "24pt" && style.fontWeight === "bold") {
      activeStyles.h1 = true;
    } else if (style.fontSize === "20pt" && style.fontWeight === "bold") {
      activeStyles.h2 = true;
    } else if (style.fontSize === "16pt" && style.fontWeight === "bold") {
      activeStyles.h3 = true;
    }

    this.setState({ activeStyles });
  };

  _handleStyleUpdate = (property, value, isIncrement = false, isHeading = false, isToggle = false, offValue = null, isList = false) => {
    console.log("toggleValue11: ", value);
    console.log("offValue: ", offValue);
    console.log("isToggle: ", isToggle)
    console.log("property: ", property)
    const { selectedElement } = this.props;
    console.log("selectedElement :", selectedElement)
    const { section, path, index } = selectedElement;

    if (!section || !path) return;

    if (path === "documentTitle" || path === "VatSummary") {
      this._handleSpecialElementStyleUpdate(section, path, property, value, isIncrement, isHeading, isToggle, offValue, isList);
      return;
    }

    const currentElement = this.props.properties[section][path][index];
    if (!currentElement) return;

    console.log("currentElement: ", currentElement);

    let newValue = value;
    // if (isList && isToggle && selectedElement?.element?.data !== "customText" && path !== "companyProps" && path === "documentTitle") {
    //   const currentListStyle = currentElement.style?.listStyleType;
    //   const toggleValue = currentListStyle === value ? offValue : value;

    //   const updatedElement = {
    //     ...currentElement,
    //     style: {
    //       ...currentElement.style,
    //       listStyleType: toggleValue,
    //       display: toggleValue !== "none" ? "list-item" : "block",
    //       marginLeft: toggleValue !== "none" ? "20px" : "0px",
    //     }
    //   };

    //   const domElement = document.getElementById(currentElement.id);
    //   if (domElement) {
    //     domElement.style.listStyleType = toggleValue;
    //     domElement.style.display = toggleValue !== "none" ? "list-item" : "block";
    //     domElement.style.marginLeft = toggleValue !== "none" ? "20px" : "0px";
    //   }

    //   this._updateElementInState(section, path, index, updatedElement);
    //   this._updateActiveStyles(updatedElement);
    //   return;
    // }
    if (isHeading && isToggle) {
      const headingStyles = {
        h1: {
          fontWeight: "bold",
          fontSize: "24pt",
          textDecoration: "none",
          fontStyle: "normal"
        },
        h2: {
          fontWeight: "bold",
          fontSize: "20pt",
          textDecoration: "none",
          fontStyle: "normal"
        },
        h3: {
          fontWeight: "bold",
          fontSize: "16pt",
          textDecoration: "none",
          fontStyle: "normal"
        },
        normal: {
          fontWeight: "normal",
          fontSize: this.props.properties.prop.fontSize + "pt",
          textDecoration: "none",
          fontStyle: "normal"
        }
      };

      const currentIsHeading =
        (currentElement.style?.fontSize === "24pt" && value === "h1") ||
        (currentElement.style?.fontSize === "20pt" && value === "h2") ||
        (currentElement.style?.fontSize === "16pt" && value === "h3");

      const toggleValue = currentIsHeading ? offValue : value;
      console.log("toggleValue: ", toggleValue);
      const headingStyle = headingStyles[toggleValue];

      const updatedElement = {
        ...currentElement,
        style: {
          ...currentElement.style,
          ...headingStyle
        }
      };

      const domElement = document.getElementById(currentElement.id);
      if (domElement) {
        Object.keys(headingStyle).forEach(prop => {
          domElement.style[prop] = headingStyle[prop];
        });
      }

      this._updateElementInState(section, path, index, updatedElement);
      this._updateActiveStyles(updatedElement);
      return;
    }
    if (isToggle) {
      const currentValue = currentElement.style?.[property];
      let toggleValue;

      if (property === "textDecoration") {
        const hasValue = currentValue === value ||
          (currentValue && currentValue.includes(value));
        toggleValue = hasValue ? offValue : value;
      } else {
        toggleValue = currentValue === value ? offValue : value;
      }

      const updatedElement = {
        ...currentElement,
        style: {
          ...currentElement.style,
          [property]: toggleValue
        }
      };

      const domElement = document.getElementById(currentElement.id);
      if (domElement) {
        domElement.style[property] = toggleValue;
      }

      this._updateElementInState(section, path, index, updatedElement);

      this._updateActiveStyles(updatedElement);
      return;
    }
    if (isIncrement && property === "fontSize") {
      let currentSize = 10;

      if (currentElement.style?.fontSize) {
        currentSize = this._parseFontSize(currentElement.style.fontSize);
      }
      else if (this.props.properties[section]?.font?.fontSize) {
        currentSize = this._parseFontSize(this.props.properties[section].font.fontSize);
      }
      else if (this.props.properties.prop?.fontSize) {
        currentSize = this._parseFontSize(this.props.properties.prop.fontSize);
      }

      newValue = (currentSize + value) + "pt";
    } else if (property === "fontSize" && !isIncrement) {
      newValue = value.toString().endsWith("pt") || value.toString().endsWith("px") ? value : value + "pt";
    }

    const updatedElement = {
      ...currentElement,
      style: {
        ...currentElement.style,
        [property]: isIncrement ? newValue : value
      }
    };

    const domElement = document.getElementById(currentElement.id);
    if (domElement) {
      domElement.style[property] = isIncrement ? newValue : value;
    }

    this._updateElementInState(section, path, index, updatedElement);

    if (property === "textAlign") {
      this._updateActiveStyles(updatedElement);
    }

    // switch (section) {
    //   case 'head':
    //     this.props.updateHead({
    //       ...this.props.properties.head,
    //       [path]: {
    //         ...this.props.properties.head[path],
    //         [index]: updatedElement
    //       }
    //     });
    //     break;

    //   case 'total':
    //     this.props.updateTotal({
    //       ...this.props.properties.total,
    //       [path]: {
    //         ...this.props.properties.total[path],
    //         [index]: updatedElement
    //       }
    //     });
    //     break;

    //   case 'foot':
    //     this.props.updateFoot({
    //       ...this.props.properties.foot,
    //       [path]: {
    //         ...this.props.properties.foot[path],
    //         [index]: updatedElement
    //       }
    //     });
    //     break;

    //   default:
    //     break;
    // }
  };

  _handleSpecialElementStyleUpdate = (section, path, property, value, isIncrement, isHeading = false, isToggle = false, offValue = null, isList = false) => {
    const currentElement = this.props.properties[section][path];
    if (!currentElement) return;
    console.log("path123: ", path)
    let newValue = value;

    // if (isList && isToggle && path !== "documentTitle" && path !== "VatSummary") {
    //   const currentListStyle = currentElement.style?.listStyleType;
    //   const toggleValue = currentListStyle === value ? offValue : value;

    //   const updatedElement = {
    //     ...currentElement,
    //     style: {
    //       ...currentElement.style,
    //       listStyleType: toggleValue,
    //       display: toggleValue !== "none" ? "list-item" : "block",
    //       marginLeft: toggleValue !== "none" ? "20px" : "0px",
    //     }
    //   };

    //   const domElement = document.getElementById(currentElement.id);
    //   if (domElement) {
    //     domElement.style.listStyleType = toggleValue;
    //     domElement.style.display = toggleValue !== "none" ? "list-item" : "block";
    //     domElement.style.marginLeft = toggleValue !== "none" ? "20px" : "0px";
    //   }

    //   switch (section) {
    //     case 'head':
    //       this.props.updateHead({
    //         ...this.props.properties.head,
    //         [path]: updatedElement
    //       });
    //       break;

    //     case 'total':
    //       this.props.updateTotal({
    //         ...this.props.properties.total,
    //         [path]: updatedElement
    //       });
    //       break;

    //     default:
    //       break;
    //   }
    //   this._updateActiveStyles(updatedElement);
    //   return;
    // }

    if (isHeading && isToggle) {
      const headingStyles = {
        h1: {
          fontWeight: "bold",
          fontSize: "24pt",
          textDecoration: "none",
          fontStyle: "normal"
        },
        h2: {
          fontWeight: "bold",
          fontSize: "20pt",
          textDecoration: "none",
          fontStyle: "normal"
        },
        h3: {
          fontWeight: "bold",
          fontSize: "16pt",
          textDecoration: "none",
          fontStyle: "normal"
        },
        normal: {
          fontWeight: "normal",
          fontSize: path === "documentTitle" ? "20pt" : (this.props.properties.prop.fontSize + "pt"),
          textDecoration: "none",
          fontStyle: "normal"
        }
      };

      const currentIsHeading =
        (currentElement.style?.fontSize === "24pt" && value === "h1") ||
        (currentElement.style?.fontSize === "20pt" && value === "h2") ||
        (currentElement.style?.fontSize === "16pt" && value === "h3");

      const toggleValue = currentIsHeading ? offValue : value;
      const headingStyle = headingStyles[toggleValue];

      const updatedElement = {
        ...currentElement,
        style: {
          ...currentElement.style,
          ...headingStyle
        }
      };

      const domElement = document.getElementById(currentElement.id);
      if (domElement) {
        Object.keys(headingStyle).forEach(prop => {
          domElement.style[prop] = headingStyle[prop];
        });
      }

      switch (section) {
        case 'head':
          this.props.updateHead({
            ...this.props.properties.head,
            [path]: updatedElement
          });
          break;

        case 'total':
          this.props.updateTotal({
            ...this.props.properties.total,
            [path]: updatedElement
          });
          break;

        default:
          break;
      }
      this._updateActiveStyles(updatedElement);
      return;
    }

    if (isToggle) {
      const currentValue = currentElement.style?.[property];
      let toggleValue;

      if (property === "textDecoration") {
        const hasValue = currentValue === value ||
          (currentValue && currentValue.includes(value));
        toggleValue = hasValue ? offValue : value;
      } else {
        toggleValue = currentValue === value ? offValue : value;
      }

      const updatedElement = {
        ...currentElement,
        style: {
          ...currentElement.style,
          [property]: toggleValue
        }
      };

      const domElement = document.getElementById(currentElement.id);
      if (domElement) {
        domElement.style[property] = toggleValue;
      }

      switch (section) {
        case 'head':
          this.props.updateHead({
            ...this.props.properties.head,
            [path]: updatedElement
          });
          break;

        case 'total':
          this.props.updateTotal({
            ...this.props.properties.total,
            [path]: updatedElement
          });
          break;

        default:
          break;
      }

      this._updateActiveStyles(updatedElement);
      return;
    }

    if (isIncrement && property === "fontSize") {
      let currentSize = 10;

      if (currentElement.style?.fontSize) {
        const sizeStr = currentElement.style.fontSize;
        currentSize = parseInt(sizeStr) || 10;
      }
      else if (path === "documentTitle") {
        currentSize = 20;
      }

      newValue = (currentSize + value) + "pt";
    } else if (property === "fontSize" && !isIncrement) {
      newValue = value.toString().endsWith("pt") ? value : value + "pt";
    }

    const updatedElement = {
      ...currentElement,
      style: {
        ...currentElement.style,
        [property]: isIncrement ? newValue : value
      }
    };

    const domElement = document.getElementById(currentElement.id);
    if (domElement) {
      domElement.style[property] = isIncrement ? newValue : value;
    }

    switch (section) {
      case 'head':
        this.props.updateHead({
          ...this.props.properties.head,
          [path]: updatedElement
        });
        break;

      case 'total':
        this.props.updateTotal({
          ...this.props.properties.total,
          [path]: updatedElement
        });
        break;

      default:
        break;
    }

    if (property === "textAlign") {
      this._updateActiveStyles(updatedElement);
    }
  };

  _parseFontSize = (fontSizeStr) => {
    if (!fontSizeStr) return 10;

    const cleanStr = fontSizeStr.toString().replace('pt', '').replace('px', '').replace('em', '').trim();
    const size = parseFloat(cleanStr);

    return isNaN(size) ? 10 : size;
  };

  _updateElementInState = (section, path, index, updatedElement) => {
    switch (section) {
      case 'head':
        if (path === "elements") {
          const elementKey = updatedElement.name.replace(/\./g, '');
          const updatedHead = {
            ...this.props.properties.head,
            elements: {
              ...this.props.properties.head.elements,
              [elementKey]: updatedElement
            }
          };
          this.props.updateHead(updatedHead);
        } else {
          const updatedHead = {
            ...this.props.properties.head,
            [path]: {
              ...this.props.properties.head[path],
              [index]: updatedElement
            }
          };
          this.props.updateHead(updatedHead);
        }
        break;

      case 'total':
        if (path === "elements") {
          const elementKey = updatedElement.name.replace(/\./g, '');
          const updatedTotal = {
            ...this.props.properties.total,
            elements: {
              ...this.props.properties.total.elements,
              [elementKey]: updatedElement
            }
          };
          this.props.updateTotal(updatedTotal);
        } else {
          const updatedTotal = {
            ...this.props.properties.total,
            [path]: {
              ...this.props.properties.total[path],
              [index]: updatedElement
            }
          };
          this.props.updateTotal(updatedTotal);
        }
        break;

      case 'foot':
        if (path === "elements") {
          const elementKey = updatedElement.name.replace(/\./g, '');
          const updatedFoot = {
            ...this.props.properties.foot,
            elements: {
              ...this.props.properties.foot.elements,
              [elementKey]: updatedElement
            }
          };
          this.props.updateFoot(updatedFoot);
        } else {
          const updatedFoot = {
            ...this.props.properties.foot,
            [path]: {
              ...this.props.properties.foot[path],
              [index]: updatedElement
            }
          };
          this.props.updateFoot(updatedFoot);
        }
        break;

      default:
        break;
    }
  };

  _closeWindow = function (e) {
    if (this.state.isEdited) this.setState({ showAlert: true });
    else this.props.callbackFromParents(e);
  };

  _confirmClose = function (e) {
    this.props.callbackFromParents(e);
  };

  _onElementClick = (e) => {
    if (e.target.tagName === 'TEXTAREA' || e.target.closest('textarea')) {
      e.preventDefault();
      e.stopPropagation();
      return false;
    }
    //  console.log(e)
    var name = e.target.getAttribute("id");
    if (name === null) {
      e.preventDefault();
      return false;
    }
    let section = e.target.getAttribute("data-section");
    let path = e.target.getAttribute("data-path");
    let index = e.target.getAttribute("data-index");
    let isCompanyProp = e.target.getAttribute("data-is-company-prop") === "true";

    if (name === null) return false;

    let element;

    if (isCompanyProp) {
      element = this.props.properties[section][path][index];
    } else if (path === "documentTitle") {
      element = this.props.properties[section][path];
    } else if (path === "VatSummary") {
      element = this.props.properties[section][path];
    } else if (path === "elements") {
      const elementKey = e.target.getAttribute("data-element")?.replace(".", "") || index;
      element = this.props.properties[section].elements[elementKey];
    } else if (path === "shapes") {
      element = this.props.properties[section].shapes[index];
    } else {
      element = this.props.properties[section][path][index];
    }
    this.props.setSelectedElement(
      section,
      path,
      index,
      element,
    );

    this.setState({
      selectedElementName: name,
    });

    this._updateActiveStyles(element);
  };

  _onShapeClick = (e) => {

    //  console.log(e)
    var name = e.target.getAttribute("id");
    if (name === null) {
      e.preventDefault();
      return false;
    }
    let section = e.target.getAttribute("data-section");
    let path = e.target.getAttribute("data-path");
    let index = e.target.getAttribute("data-index");

    if (name === null) return false;

    const element = this.props.properties[section].shapes[index];
    this.props.setSelectedElement(
      section,
      path,
      index,
      element
    );

    this.setState({
      selectedElementName: name,
    });

    this._updateActiveStyles(element);
  };

  _onVatSummaryClick = (e) => {
    var name = e.target.getAttribute("id");
    if (name === null) {
      e.preventDefault();
      return false;
    }
    let section = 'total'//e.target.getAttribute("data-section");
    let path = "VatSummary"//e.target.getAttribute("data-path");
    let index = e.target.getAttribute("data-index");

    if (name === null) return false;

    const element = this.props.properties[section].VatSummary;
    this.props.setSelectedElement(
      section,
      path,
      index,
      element
    );

    this.setState({
      selectedElementName: name,
    });

    this._updateActiveStyles(element);
  }

  //#region Resize Element
  _resizeMouseDown = (e) => {
    console.log(e)
    e.preventDefault();
    // this.selectedElementResizeOn = true;
    this.setState({
      selectedElementResizeOn: true
    })
  };

  _resizeMouseMove = (e) => {
    if (this.state.selectedElementResizeOn) {
      var elementName = this.state.selectedElementName;
      var width = document.getElementById(elementName).offsetWidth;
      var height = document.getElementById(elementName).offsetHeight;
      var props = this.props.properties;
      var sect = props[this.section];
      //console.log(this.section);

      this.setState(
        {
          properties: {
            ...props,
            [this.section]: {
              ...sect,
              logo: {
                ...sect.logo,
                style: {
                  ...sect.logo.style,
                  width: width + e.movementX + "px",
                  height: height + e.movementY + "px",
                },
              },
              elements: [
                ...sect.elements.slice(0, this.index),
                {
                  ...sect.elements[this.index],
                  style: {
                    ...sect.elements[this.index].style,
                    width: width + e.movementX + "px",
                    height: height + e.movementY + "px",
                  },
                },
                ...sect.elements.slice(this.index + 1),
              ],
            },
          },
        },
        function () { }
      );
    }
  };

  _resizeMouseUp = (e) => {
    e.preventDefault();
    // this.selectedElementResizeOn = false;
    this.setState({
      selectedElementResizeOn: false
    })
  };

  _resizeMouseLeave = (e) => {
    e.preventDefault();
    // this.selectedElementResizeOn = false;
    this.setState({
      selectedElementResizeOn: false
    })
  };

  //#endregion

  //#region Move Element
  _moveMouseDown = (e) => {
    e.preventDefault();
    // this.selectedElementMoveOn = true;
    this.setState({
      selectedElementMoveOn: true
    })
  };

  _moveMouseMove = (e) => {
    if (this.state.selectedElementMoveOn) {

      var elementName = this.state.selectedElementName;
      const newManuallyPositioned = new Set(this.state.manuallyPositionedElements);
      newManuallyPositioned.add(elementName);
      this.setState({ manuallyPositionedElements: newManuallyPositioned });
      var top = parseInt(document.getElementById(elementName).style.top) >= 0 ?
        parseInt(
          document
            .getElementById(elementName)
            .style.top.toString()
            .replace("px", "")
        ) : 0;
      var left = parseInt(document.getElementById(elementName).style.left) >= 0 ?
        parseInt(
          document
            .getElementById(elementName)
            .style.left.toString()
            .replace("px", "")
        ) : 0;

      const section = document.getElementById(elementName).getAttribute("data-section");
      const path = document.getElementById(elementName).getAttribute("data-path");
      const index = document.getElementById(elementName).getAttribute("data-index");
      const isCompanyProp = document.getElementById(elementName).getAttribute("data-is-company-prop") === "true";
      const isDocumentTitleId = document.getElementById(elementName).getAttribute("id") === "doc-title";

      const newTop = top + e.movementY;
      const newLeft = left + e.movementX;

      document.getElementById(elementName).style.top = newTop + "px";
      document.getElementById(elementName).style.left = newLeft + "px";

      // console.log("document: ", document.getElementById(elementName))

      // console.log("pathhh: ", path)

      // console.log("newTop: ", newTop)

      // console.log("newLeft: ", newLeft)
      if (isDocumentTitleId) {
        console.log("Moving documentTitle to:", newLeft, newTop);

        const updatedDocumentTitle = {
          ...this.props.properties.head.documentTitle,
          style: {
            ...this.props.properties.head.documentTitle.style,
            top: newTop + "px",
            left: newLeft + "px"
          }
        };

        console.log("Updated documentTitle:", updatedDocumentTitle);

        this.props.updateHead({
          ...this.props.properties.head,
          documentTitle: updatedDocumentTitle
        });
      }

      if (isCompanyProp && path === "companyProps") {
        const updatedCompanyProps = {
          ...this.props.properties.head.companyProps,
          [index]: {
            ...this.props.properties.head.companyProps[index],
            style: {
              ...this.props.properties.head.companyProps[index].style,
              top: newTop + "px",
              left: newLeft + "px"
            }
          }
        };

        this.props.updateHead({
          ...this.props.properties.head,
          companyProps: updatedCompanyProps
        });
      } else {
        this.props.moveElement(newTop, newLeft);
      }
    } else if (this.state.selectedElementResizeOn) {
      var elementName = this.state.selectedElementName;

      var width = document.getElementById(elementName).offsetWidth;
      var height = document.getElementById(elementName).offsetHeight;

      this.props.resizeElement(height + e.movementY, width + e.movementX);
    }
  };

  _moveMouseUp = (e) => {
    e.preventDefault();
    // this.selectedElementMoveOn = false;
    this.setState({
      selectedElementMoveOn: false
    })
  };

  _moveMouseLeave = (e) => {
    e.preventDefault();
    //this.selectedElementMoveOn = false;
    this.setState({
      selectedElementMoveOn: false
    })
  };
  //#endregion

  _getBestPositionForNewElement = (elementWidth, elementHeight, existingElements) => {
    const GRID_SIZE = 10;
    const START_X = 40;
    const START_Y = 40;
    const MAX_X = 800;
    const MAX_Y = 400;

    const gridPositions = [];

    for (let y = START_Y; y < MAX_Y - elementHeight; y += GRID_SIZE) {
      for (let x = START_X; x < MAX_X - elementWidth; x += GRID_SIZE) {
        gridPositions.push({ x, y });
      }
    }

    gridPositions.sort((a, b) => {
      if (a.y !== b.y) return a.y - b.y;
      return a.x - b.x;
    });

    for (const position of gridPositions) {
      const testRect = {
        top: position.y,
        left: position.x,
        right: position.x + elementWidth,
        bottom: position.y + elementHeight,
        width: elementWidth,
        height: elementHeight
      };

      let hasOverlap = false;

      for (const existingElement of existingElements) {
        const existingRect = this._getElementDimensions(existingElement.id);

        if (this._checkRectOverlap(testRect, existingRect)) {
          hasOverlap = true;
          break;
        }
      }

      if (!hasOverlap) {
        return { top: position.y, left: position.x };
      }
    }

    return { top: MAX_Y - elementHeight, left: START_X };
  };

  _checkRectOverlap = (rect1, rect2) => {
    const MARGIN = 5;

    return !(
      rect1.right + MARGIN < rect2.left ||
      rect2.right + MARGIN < rect1.left ||
      rect1.bottom + MARGIN < rect2.top ||
      rect2.bottom + MARGIN < rect1.top
    );
  };

  //#endregion

  _showToolTips = (obj) => {
    this.setState({ showToolTips: obj });
  };

  _renderElements = (section) => {
    var index = 0;
    return (
      this.props.properties &&
      Object.keys(this.props.properties[section].elements).map((key) => {
        var data = this.props.properties[section].elements[key];
        const defaultFontColor = this.props.properties.prop.fontColor;
        const defaultFontSize = this.props.properties.prop.fontSize + "pt";
        const sectionFont = this.props.properties[section]?.font || {
          fontFamily: 'Inter',
          fontSize: this.props.properties.prop.fontSize,
          color: this.props.properties.prop.fontColor
        };

        var dStyle = Object.assign({}, data.style);
        dStyle.fontFamily = data.style?.fontFamily || sectionFont.fontFamily || 'Inter';
        if (!dStyle.color) {
          dStyle.color = sectionFont.color || defaultFontColor;
        }
        if (!dStyle.fontSize) {
          dStyle.fontSize = sectionFont.fontSize ? sectionFont.fontSize + "pt" : defaultFontSize;
        }
        if (!dStyle.fontWeight) {
          dStyle.fontWeight = data.style?.fontWeight || 'normal';
        }
        if (!dStyle.fontStyle) {
          dStyle.fontStyle = data.style?.fontStyle || 'normal';
        }
        if (!dStyle.textDecoration) {
          dStyle.textDecoration = data.style?.textDecoration || 'none';
        }
        if (!dStyle.textAlign) {
          dStyle.textAlign = data.style?.textAlign || 'left';
        }

        const isSelected = this.state.selectedElementName == data.id;

        return (
          <TemplateElement
            key={data.id}
            elementId={data.id}
            element={{
              ...data,
              section: section
            }}
            style={dStyle}
            isSelected={isSelected}
            onClick={(e) => this._onElementClick(e)}
            onMount={(id, domElement) => {
              console.log(`TemplateElement mounted: ${id}`);
              this._registerElementRef(id, domElement);
            }}
            onUnmount={(id) => {
              console.log(`TemplateElement unmounted: ${id}`);
              this._unregisterElementRef(id);
            }}
            renderElementControl={() => this._renderElementControl()}
          />
        );
      })
    );
  };

  _renderVatSummary = () => {
    var index = 0;

    if (this.props.properties.total.VatSummary && Object.keys(this.props.properties.total.VatSummary).length > 0) {
      var data = this.props.properties.total.VatSummary;
      const defaultFontColor = this.props.properties.prop.fontColor;
      const defaultFontSize = this.props.properties.prop.fontSize + "pt";

      const sectionFont = this.props.properties.total?.font || { fontFamily: 'Inter', fontSize: this.props.properties.prop.fontSize, color: this.props.properties.prop.fontColor };

      var dStyle = Object.assign({}, data.style);
      dStyle.width = 320
      dStyle.height = 100

      dStyle.fontFamily = data.style?.fontFamily || sectionFont.fontFamily || 'Inter';

      if (!dStyle.color) {
        dStyle.color = sectionFont.color || defaultFontColor;
      }

      if (!dStyle.fontSize) {
        dStyle.fontSize = sectionFont.fontSize ? sectionFont.fontSize + "pt" : defaultFontSize;
      }

      if (!dStyle.fontWeight) {
        dStyle.fontWeight = data.style?.fontWeight || 'normal';
      }
      if (!dStyle.fontStyle) {
        dStyle.fontStyle = data.style?.fontStyle || 'normal';
      }
      if (!dStyle.textDecoration) {
        dStyle.textDecoration = data.style?.textDecoration || 'none';
      }
      if (!dStyle.textAlign) {
        dStyle.textAlign = data.style?.textAlign || 'left';
      }
      const isList = dStyle.listStyleType && dStyle.listStyleType !== 'none';
      const textLines = data.text ? data.text.split('\n') : [''];

      index++;
      var id = sha256("vat-summary-ele-" + index);
      var isSelected = this.state.selectedElementName == data.id;
      return (
        <div
          onClick={(e) => this._onVatSummaryClick(e)}
          key={data.id}
          style={dStyle}
          id={data.id}
          data-element={data.name}
          data-section="total"
          data-path="elements"
          data-index="VatSummary"
          className={
            "custom-element" + (isSelected ? " selected-element" : "")
          }
        >
          {isList ? (
            <ul style={{
              margin: 0,
              padding: 0,
              paddingLeft: dStyle.listStyleType === 'decimal' ? '25px' : '20px',
              listStyleType: dStyle.listStyleType
            }}>
              {textLines.map((line, idx) => (
                <li key={idx} style={{
                  color: dStyle.color,
                  fontSize: dStyle.fontSize,
                  fontFamily: dStyle.fontFamily,
                  fontWeight: dStyle.fontWeight,
                  fontStyle: dStyle.fontStyle,
                  textDecoration: dStyle.textDecoration,
                  textAlign: dStyle.textAlign,
                  marginBottom: idx < textLines.length - 1 ? '4px' : '0'
                }}>
                  {line || '\u00A0'}
                </li>
              ))}
            </ul>
          ) : (
            data.text
          )}
          {isSelected ? this._renderElementControl() : <></>}
        </div>
      );
    }

  };

  _renderShapes = (section) => {
    var index = 0;
    return (
      this.props.properties && this.props.properties[section].shapes && Object.keys(this.props.properties[section].shapes).length > 0 &&
      Object.keys(this.props.properties[section].shapes).filter(s => s !== 'border').map((key) => {
        var data = this.props.properties[section].shapes[key];
        var font = this.props.properties[section]?.font || { fontFamily: 'Inter', fontSize: 10 }
        var borderColor = this.props.properties[section].shapes.border.color
        var borderSize = this.props.properties[section].shapes.border.size
        var bgColor = this.props.properties[section].shapes.border.fillColor
        var dStyle = Object.assign({ minWidth: '32px', minHeight: '16px' }, data.style);
        dStyle.border = `${borderSize}px solid ${borderColor}`;
        dStyle.background = `${bgColor}`

        index++;
        var id = sha256(section + "-ele-" + index);
        var isSelected = this.state.selectedElementName == data.id;
        return (
          <div
            onClick={(e) => this._onShapeClick(e)}
            key={data.id}
            style={Object.assign(dStyle, font)}
            id={data.id}
            data-element={data.name}
            data-section={section}
            data-path="shapes"
            data-index={data.name ? data.name.replace(".", "") : ""}
            className={
              "custom-element" + (isSelected ? " selected-element" : "")
            }
          >
            {isSelected ? this._renderElementControl() : <></>}
          </div>
        );
      })
    );
  };


  _renderImage = (section) => {
    if (this.props.properties.head && this.props.properties.head.logo && Object.keys(this.props.properties.head.logo).length > 0) {
      var index = 0;
      index++;
      //console.log(this.props.properties.head.logo);
      var id = sha256(section + "img-ele" + index);
      var isSelected =
        this.state.selectedElementName == id;

      const logoStyle = {
        ...this.props.properties.head.logo.style,
        zIndex: 0,
      };

      return this.props.properties.head.logo.showLogo &&
        this.props.properties.head.logo.logo !== null ? (
        <div
          onClick={(e) => {
            this._onElementClick(e)
          }}
          style={logoStyle}
          key={this.props.properties.head.logo.id}
          id={id}
          data-element={this.props.properties.head.logo.name}
          data-section={section}
          data-path="logo"
          data-index=""
          className={"custom-element" + (isSelected ? " selected-element" : "")}
        >
          <div>
            <img
              src={this.state.tempLogo ? this.state.tempLogo : this.props.properties.head.logo.logo}
              style={{
                width:
                  (this.props.properties
                    ? this.props.properties.head.logo.logoSize
                    : 100) + "%",
                pointerEvents: "none",
              }}
            />
          </div>
          {isSelected ? this._renderElementControl() : <></>}
        </div>
      ) : (
        <></>
      );
    } else {
      return null
    }
  };

  _renderCompanyElements = () => {
    if (this.props.properties.head && this.props.properties.head.companyProps && Object.keys(this.props.properties.head.companyProps).length > 0) {
      var index = 0;
      return Object.keys(this.props.properties?.head?.companyProps).map((key) => {
        var prop = this.props.properties.head.companyProps[key];

        if (!prop.show) return null;

        const defaultFontColor = this.props.properties.prop.fontColor;
        const defaultFontSize = this.props.properties.prop.fontSize + "pt";
        const sectionFont = this.props.properties.head?.font || {
          fontFamily: 'Inter',
          fontSize: this.props.properties.prop.fontSize,
          color: this.props.properties.prop.fontColor
        };

        var dStyle = Object.assign({}, prop.style);
        dStyle.fontFamily = prop.style?.fontFamily || sectionFont.fontFamily || 'Inter';
        if (!dStyle.color) {
          dStyle.color = sectionFont.color || defaultFontColor;
        }
        if (!dStyle.fontSize) {
          dStyle.fontSize = sectionFont.fontSize ? sectionFont.fontSize + "pt" : defaultFontSize;
        }
        if (!dStyle.fontWeight) {
          dStyle.fontWeight = prop.style?.fontWeight || 'normal';
        }
        if (!dStyle.fontStyle) {
          dStyle.fontStyle = prop.style?.fontStyle || 'normal';
        }
        if (!dStyle.textDecoration) {
          dStyle.textDecoration = prop.style?.textDecoration || 'none';
        }
        if (!dStyle.textAlign) {
          dStyle.textAlign = prop.style?.textAlign || 'left';
        }

        const isSelected = this.state.selectedElementName == prop.id;

        return (
          <TemplateElement
            key={prop.id}
            elementId={prop.id}
            element={{
              ...prop,
              section: "head",
              name: prop.name,
              text: prop.text,
              isCompanyProp: true,
              propKey: key
            }}
            style={dStyle}
            isSelected={isSelected}
            onClick={(e) => this._onElementClick(e)}
            onMount={(id, domElement) => this._registerElementRef(id, domElement)}
            onUnmount={(id) => this._unregisterElementRef(id)}
            renderElementControl={() => this._renderElementControl()}
            dataAttributes={{
              "data-section": "head",
              "data-path": "companyProps",
              "data-index": key,
              "data-element": prop.name,
              "data-is-company-prop": "true"
            }}
          />
        );
      });
    } else {
      return null;
    }
  };

  _renderDocumentTitle = () => {
    if (this.props.properties.head && this.props.properties.head.documentTitle && Object.keys(this.props.properties.head.documentTitle).length > 0) {
      var title = this.props.properties.head.documentTitle;

      // console.log("docTitle: ", title)

      if (!title.show) return null;

      const defaultFontColor = this.props.properties.prop.fontColor;
      var dStyle = Object.assign({}, title.style);
      if (!dStyle.color) {
        dStyle.color = defaultFontColor;
      }
      if (!dStyle.fontFamily && this.props.properties.head?.font?.fontFamily) {
        dStyle.fontFamily = this.props.properties.head.font.fontFamily;
      } else if (!dStyle.fontFamily) {
        dStyle.fontFamily = 'Inter';
      }
      if (!dStyle.fontSize) {
        dStyle.fontSize = "20pt";
      }
      if (!dStyle.fontWeight) {
        dStyle.fontWeight = title.style?.fontWeight || 'bold';
      }
      if (!dStyle.fontStyle) {
        dStyle.fontStyle = title.style?.fontStyle || 'normal';
      }
      if (!dStyle.textDecoration) {
        dStyle.textDecoration = title.style?.textDecoration || 'none';
      }
      if (!dStyle.textAlign) {
        dStyle.textAlign = title.style?.textAlign || 'center';
      }

      const isSelected = this.state.selectedElementName == title.id;

      return (
        <TemplateElement
          key={title.id}
          elementId={title.id}
          element={{
            ...title,
            section: "head",
            name: title.name,
            text: title.title
          }}
          style={dStyle}
          isSelected={isSelected}
          onClick={(e) => this._onElementClick(e)}
          onMount={(id, domElement) => this._registerElementRef(id, domElement)}
          onUnmount={(id) => this._unregisterElementRef(id)}
          renderElementControl={() => this._renderElementControl()}
        />
      );
    } else {
      return null;
    }
  };

  _renderElementControl = () => {
    return (
      <div className="resize">
        <span
          className="top-left"
          onMouseDown={(e) => this._moveMouseDown(e)}
          onMouseUp={(e) => this._moveMouseUp(e)}
        ></span>

        <span
          className="bottom-right"
          onMouseDown={(e) => this._resizeMouseDown(e)}
          onMouseUp={(e) => this._resizeMouseUp(e)}
        ></span>
      </div>
    );
  };

  _renderBodyElements = (displayData) => {
    // const totalWidth = Object.keys(displayData).map(t => displayData[t])
    // .reduce((a, b) => {
    //   return  a + Number(b.width?b.width:10); // returns object with property x
    // }, 0)
    // console.log("totalWidth===>", totalWidth)
    return (
      <div style={{
        border: `1px solid ${this.props.properties.items.layout.tableBorder}`,
        borderRadius: "4px",
        overflow: "hidden"
      }}>
        <table
          style={{
            width: "100%",
            borderCollapse: "collapse",
          }}
        >
          <thead>
            <tr style={{ height: "32px" }}>
              {displayData.map((obj, key) => {
                if (displayData[key]) {
                  return (
                    <td
                      width={obj.width ? (obj.width / (displayData.reduce((a, v) => { return (a + Number(v.width ? v.width : 10)) }, 0)) * 100 + "%") : 'auto'}
                      style={{
                        padding: "5px 0px 5px 5px",
                        backgroundColor: this.props.properties.items.layout.tableHeader.backgroundColor,
                        fontSize: this.props.properties.items.layout.tableHeader.fontSize + "pt",
                        fontFamily: this.props.properties.items.layout.tableHeader.fontFamily,
                        color: this.props.properties.items.layout.tableHeader.fontColor,
                        // borderRight: this.props.properties.items.layout.itemRow.showVerticleLines ?
                        //   `${this.props.properties.items.layout.itemRow.verticleLineSize}px solid ${this.props.properties.items.layout.itemRow.verticleLineColor}` :
                        //   'none',
                        // borderLeft: key === 0 && this.props.properties.items.layout.itemRow.showVerticleLines ?
                        //   `${this.props.properties.items.layout.itemRow.verticleLineSize}px solid ${this.props.properties.items.layout.itemRow.verticleLineColor}` :
                        //   'none'
                      }}
                      key={`dd_${key}`}
                    >
                      {obj.stringFormat ? obj.stringFormat : obj.header}
                    </td>
                  );
                }
                return null;
              })}
            </tr>
          </thead>
          <tbody>
            {[...Array(50)].map((x, i) => (
              <tr key={`tr1k_${i}`} style={{
                borderBottom: this.props.properties.items.layout.itemRow.showHorizontalLines ?
                  `${this.props.properties.items.layout.itemRow.horizontalLineSize}px solid ${this.props.properties.items.layout.itemRow.horizontalLineColor}` :
                  'none'
              }}>
                {Object.keys(this.props.properties.items.items).map((key, j) => {
                  if (this.props.properties.items.items[key]) {
                    return (
                      <td
                        style={{
                          padding: "10px 0px 10px 20px",
                          textAlign: "left",
                          backgroundColor: this.props.properties.items.layout.itemRow.backgroundColor,
                          fontSize: this.props.properties.items.layout.itemRow.fontSize + "pt",
                          color: this.props.properties.items.layout.itemRow.fontColor,
                          borderRight: this.props.properties.items.layout.itemRow.showVerticleLines ?
                            `${this.props.properties.items.layout.itemRow.verticleLineSize}px solid ${this.props.properties.items.layout.itemRow.verticleLineColor}` :
                            'none',
                          borderLeft: j === 0 && this.props.properties.items.layout.itemRow.showVerticleLines ?
                            `${this.props.properties.items.layout.itemRow.verticleLineSize}px solid ${this.props.properties.items.layout.itemRow.verticleLineColor}` :
                            'none'
                        }}
                        key={`td1k_${j}`}
                      >
                        {"---"}
                      </td>
                    );
                  }
                  return null;
                })}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    );
  };

  _handleSplitSize = (s) => {
    console.log("XXXXX==>>", s)
    this.props.updateSplitSizes(s.map(size => Number(size * 100)))
    this.setState({
      splitSizes: s
    })

  }

  _saveTemplate = async (e) => {

    const htmlString = renderToString(<HTMLTemplate properties={this.props.properties} heights={this.props.heights} tempLogo={this.state.tempLogo} />);
    const htmlHeaderString = renderToString(<HTMLHeaderTemplate properties={this.props.properties} heights={this.props.heights} tempLogo={this.state.tempLogo} />);
    const htmlTotalString = renderToString(<HTMLTotalTemplate properties={this.props.properties} heights={this.props.heights} tempLogo={this.state.tempLogo} />);
    const htmlFooterString = renderToString(<HTMLFooterTemplate properties={this.props.properties} heights={this.props.heights} tempLogo={this.state.tempLogo} />);
    let encodedHTMLString = encodeURI(htmlString)
    let encodedHTMLHeaderString = encodeURI(htmlHeaderString)
    let encodedHTMLFooterString = encodeURI(htmlFooterString)
    let encodedHTMLTotalString = encodeURI(htmlTotalString)
    console.log(htmlString);
    if (this.state.isSaving) return false;
    this.setState({ isSaving: true }, function () {
      SaveTemplate(encodedHTMLString, encodedHTMLHeaderString, encodedHTMLFooterString, encodedHTMLTotalString).then((response) => {
        this.setState({ isSaved: response.data.Status });
        if (response.data.Status) {

          this.setState(
            {
              isSaving: false,
              isEdited: false,
              successMessage:
                "The template is saved. Please keep editing the template or Click the close(x) button in the top right corner of the screen",
            },
            function () {
              const timer = setTimeout(() => {
                // this.props.callbackFromParents(e);
                //console.log("Redirecting...");
              }, 3000);
            }
          );
        } else {
          this.setState({
            errorMessage: response.data
              ? response.data.Result
              : response.message,
            isSaving: false,
          });
        }
        //console.log(response.data.Status);
      });
    });
  };

  _handleImageRemove = () => {
    this.props.removeHeaderImage()
    this.setState({
      tempLogo: null
    })
  }

  renderMenu() {
    const arr = this.state.selectedSection.toString().toLowerCase();
    var elements = Object.keys(INVOICE_SECTIONS).map((e, k) => {
      e = e.toString().toLowerCase();
      return (
        <li
          key={`li1key_${k}`}
          className="nav-item"
          onClick={() => this._setSelectedSection(e)}
        >
          <a className={"nav-link" + (arr === e ? " active" : "")}>
            {(() => {
              switch (e) {
                case INVOICE_SECTIONS.PROPS:
                  return <FontAwesomeIcon icon="border-all" />;

                case INVOICE_SECTIONS.HEAD:
                  return <FontAwesomeIcon icon="angle-up" />;

                case INVOICE_SECTIONS.ITEMS:
                  return <FontAwesomeIcon icon="align-justify" />;

                case INVOICE_SECTIONS.TOTAL:
                  return <FontAwesomeIcon icon="file-alt" />;

                case INVOICE_SECTIONS.FOOT:
                  return <FontAwesomeIcon icon="angle-down" />;
              }
            })()}
            <span>{e}</span>
          </a>
        </li>
      );
    });

    return elements;
  }

  _getButtonActiveState = (buttonObj) => {
    const { activeStyles } = this.state;

    if (buttonObj.property === "fontWeight" && buttonObj.value === "bold") {
      return activeStyles.bold;
    }
    if (buttonObj.property === "fontStyle" && buttonObj.value === "italic") {
      return activeStyles.italic;
    }
    if (buttonObj.property === "textDecoration") {
      if (buttonObj.value === "underline") return activeStyles.underline;
      if (buttonObj.value === "line-through") return activeStyles.strikethrough;
    }
    if (buttonObj.property === "textAlign") {
      if (buttonObj.value === "left") return activeStyles.alignStart;
      if (buttonObj.value === "center") return activeStyles.alignCenter;
      if (buttonObj.value === "right") return activeStyles.alignEnd;
    }
    if (buttonObj.property === "listStyleType") {
      if (buttonObj.value === "disc") return activeStyles.listBullet;
      if (buttonObj.value === "decimal") return activeStyles.listNumbered;
    }
    if (buttonObj.isHeading) {
      const element = this.props.selectedElement.element;
      if (!element || !element.style) return false;

      const headingStyles = {
        h1: { fontWeight: "bold", fontSize: "24pt" },
        h2: { fontWeight: "bold", fontSize: "20pt" },
        h3: { fontWeight: "bold", fontSize: "16pt" }
      };

      const headingStyle = headingStyles[buttonObj.value];
      if (!headingStyle) return false;

      return element.style.fontSize === headingStyle.fontSize &&
        element.style.fontWeight === headingStyle.fontWeight;
    }
    return false;
  };

  render() {
    return (
      <>
        <div
          className="fullscreen-bg"
          onMouseUp={(e) => {
            // this.selectedElementResizeOn = false;
            // this.selectedElementMoveOn = false;
            this.setState({
              selectedElementResizeOn: false,
              selectedElementMoveOn: false
            })
          }}
          onMouseMove={(e) => this._moveMouseMove(e)}
        >
          <div className="column nav-column bg-primary">
            <ul className="nav navbar-nav flex-column">{this.renderMenu()}</ul>
          </div>
          <div className="column nav-options-column">
            <div
              className={
                this.state.selectedSection == INVOICE_SECTIONS.PROPS
                  ? ""
                  : "d-none"
              }
            >
              <Properties
                {...this.props}
                callbackFromParents={(obj) => {
                  this._changeProprtyProp("prop", obj);
                }}
                showToolTips={(obj) => {
                  this._showToolTips(obj);
                }}
              />
            </div>
            <div
              className={
                this.state.selectedSection == INVOICE_SECTIONS.HEAD
                  ? ""
                  : "d-none"
              }
            >
              {this.state.attributes && (
                <Head
                  {...this.props}
                  attributes={this.state.attributes}
                  properties={this.props.properties.head}
                  callbackFromParents={(obj) => {
                    this._changeProprtyProp("head", obj);
                  }}
                  showToolTips={(obj) => {
                    this._showToolTips(obj);
                  }}
                  onElementSelected={this._selectElementFromChild}
                  handleImageRemove={this._handleImageRemove}
                  updateTempLogo={(tempimg) => this.setState({ tempLogo: tempimg })}
                  manuallyPositionedElements={this.state.manuallyPositionedElements}
                  onAutoReorganize={() => {
                    this._autoReorganizeElements();
                  }}
                  onElementMoved={(elementId) => {
                    const newSet = new Set(this.state.manuallyPositionedElements);
                    newSet.add(elementId);
                    this.setState({ manuallyPositionedElements: newSet });
                  }}
                />
              )}
            </div>
            <div
              className={
                this.state.selectedSection == INVOICE_SECTIONS.ITEMS
                  ? ""
                  : "d-none"
              }
            >
              {this.state.attributes && (
                <Items
                  {...this.props}
                  attributes={this.state.attributes}
                  callbackFromParents={(obj) => {
                    this._changeProprtyProp("items", obj);
                  }}
                  showToolTips={(obj) => {
                    this._showToolTips(obj);
                  }}
                />
              )}
            </div>
            <div
              className={
                this.state.selectedSection == INVOICE_SECTIONS.TOTAL
                  ? ""
                  : "d-none"
              }
            >
              {this.state.attributes && (
                <Total
                  {...this.props}
                  onElementSelected={this._selectElementFromChild}
                  attributes={this.state.attributes}
                  callbackFromParents={(obj) => {
                    this._changeProprtyProp("total", obj);
                  }}
                  manuallyPositionedElements={this.state.manuallyPositionedElements}
                  onAutoReorganize={() => {
                    this._autoReorganizeTotalElements();
                  }}
                  onElementMoved={(elementId) => {
                    const newSet = new Set(this.state.manuallyPositionedElements);
                    newSet.add(elementId);
                    this.setState({ manuallyPositionedElements: newSet });
                  }}
                />
              )}
            </div>
            <div
              className={
                this.state.selectedSection == INVOICE_SECTIONS.FOOT
                  ? ""
                  : "d-none"
              }
            >
              {this.state.attributes && (
                <Foot
                  {...this.props}
                  attributes={this.state.attributes}
                  callbackFromParents={(obj) => {
                    this._changeProprtyProp("foot", obj);
                  }}
                  showToolTips={(obj) => {
                    this._showToolTips(obj);
                  }}
                  onElementSelected={this._selectElementFromChild}
                  manuallyPositionedElements={this.state.manuallyPositionedElements}
                  onAutoReorganize={() => {
                    this._autoReorganizeFootElements();
                  }}
                  onElementMoved={(elementId) => {
                    const newSet = new Set(this.state.manuallyPositionedElements);
                    newSet.add(elementId);
                    this.setState({ manuallyPositionedElements: newSet });
                  }}
                />
              )}
            </div>
          </div>
          <div className="column nav-editor border-0">
            <div className="new-template">
              <div className="browser">
                <div className="browser_wrapper">
                  <div className="address-bar border-bottom d-flex">
                    <div className="address-bar_dots mr-auto">
                      <span className="dot-1"></span>
                      <span className="dot-2"></span>
                      <span className="dot-3"></span>
                    </div>
                    <div className="ms-auto d-flex align-items-center">
                      <Form className="me-auto">
                        <ul className="address-bar_menu">
                          <li key="chkshowPageGridLines">
                            <Form.Group controlId="chkshowPageGridLines">
                              <Form.Check
                                onChange={(e) => {
                                  this.setState({
                                    showPageGridLines: e.target.checked,
                                  });
                                }}
                                checked={this.state.showPageGridLines}
                                label="Show page grid-lines"
                              />
                            </Form.Group>
                          </li>
                          <li key="chkshowGridLines">
                            <Form.Group controlId="">
                              <Form.Check
                                onChange={(e) => {
                                  this.setState({
                                    showGridLines: e.target.checked,
                                  });
                                }}
                                checked={this.state.showGridLines}
                                name={"showGridLines"}
                                label="Show grid-lines"
                              />
                            </Form.Group>
                          </li>
                          <li key="chkshowPointer">
                            <Form.Group controlId="chkshowPointer">
                              <Form.Check
                                onChange={(e) => {
                                  this.setState({
                                    showPointer: e.target.checked,
                                  });
                                }}
                                checked={this.state.showPointer}
                                label="Show pointer"
                              />
                            </Form.Group>
                          </li>
                        </ul>
                      </Form>
                      <a
                        className="ms-auto p-3"
                        onClick={(e) => this._closeWindow(e)}
                        style={{ cursor: "pointer" }}
                      >
                        <FontAwesomeIcon icon="times" />
                      </a>
                    </div>
                  </div>
                  <div
                    className="canves-wrapper"
                    onMouseMove={(e) => this._slideMouseMove(e)}
                    ref={(ref) => (this.canvesWrapper = ref)}
                  >
                    <div
                      className="canves"
                      style={this.props.properties.prop.orientation === "portrait" ? { width: '210mm', height: '297mm' } : { width: '297mm', height: '210mm' }}
                      ref={(ref) => (this.canves = ref)}
                    ></div>
                    <Ruler
                      width={this.state.wrapper.width}
                      height={this.state.wrapper.height}
                      showPageGridLines={this.state.showPageGridLines}
                      showGridLines={this.state.showGridLines}
                      showPointer={this.state.showPointer}
                      setMeasureSpec={(e) => this._setMeasureSpec(e)}
                      orientation={this.props.properties.prop.orientation}
                      paperSize={this.props.properties.prop.paperSize}
                    >
                      <div className="canves-content-wrapper">
                        <div
                          className="canves-content"
                          style={{
                            backgroundColor: this.props.properties.prop
                              .background.showColor
                              ? this.props.properties.prop.background.color
                              : "transparent",
                            width: this.props.properties.prop.orientation === "portrait" ? '210mm' : '297mm',
                            height: this.props.properties.prop.orientation === "portrait" ? '297mm' : '210mm',
                            position: 'relative',
                          }}
                        >
                          {this.props.properties.prop.background.showImage && this.props.properties.prop.background.image && (
                            <div
                              className="background-image-layer"
                              style={{
                                position: 'absolute',
                                top: 0,
                                left: 0,
                                right: 0,
                                bottom: 0,
                                backgroundImage: `url(${this.props.properties.prop.background.image})`,
                                backgroundSize: this.props.properties.prop.background.imageSize
                                  ? `${this.props.properties.prop.background.imageSize}%`
                                  : 'cover',
                                backgroundPosition: 'center',
                                backgroundRepeat: 'no-repeat',
                                opacity: this.props.properties.prop.background.opacity || 1,
                                zIndex: 0,
                              }}
                            />
                          )}

                          <div
                            className="content-container"
                            style={{
                              position: 'relative',
                              zIndex: 1,
                            }}
                          >
                            <div id="templateContainer">
                              <div className="simple-vertical">
                                <Split
                                  className="split-vertical"
                                  style={this.props.properties.prop.orientation === "portrait" ? { height: '297mm' } : { height: '210mm' }}
                                  direction="vertical"
                                  sizes={this.state.splitSizes}
                                  onSetSizes={this._handleSplitSize}
                                >
                                  <div
                                    className="content canves-header "
                                    style={{
                                      height: '100%',
                                      backgroundColor: this.props.properties.head
                                        .background.showColor
                                        ? this.props.properties.head.background.color
                                        : "transparent",
                                    }}
                                  >
                                    <div
                                      className="canves-content-children"
                                      style={{
                                        marginTop:
                                          this.props.properties.prop.margin ? this.props.properties.prop.margin.top *
                                            this.state.measureSpec.in : this.state.measureSpec.in +
                                          "px",
                                        marginLeft:
                                          this.props.properties.prop.margin ?
                                            this.props.properties.prop.margin.left *
                                            this.state.measureSpec.in : this.state.measureSpec.in +
                                            "px",
                                        marginRight:
                                          this.props.properties.prop.margin ? this.props.properties.prop.margin.right *
                                            this.state.measureSpec.in : this.state.measureSpec.in +
                                          "px",
                                        borderBottom: 0,
                                      }}
                                    >
                                      <div>
                                        {this._renderShapes("head")}
                                        {this._renderCompanyElements()}
                                        {this._renderElements("head")}
                                        {this._renderImage("head")}
                                        {this._renderDocumentTitle()}
                                      </div>
                                    </div>
                                    <span className="info">Header</span>
                                    <span
                                      onMouseDown={(e) =>
                                        this._slideMouseDown(e, "head")
                                      }
                                      onMouseUp={(e) => this._slideMouseUp(e)}
                                      className="slider"
                                    ></span>
                                  </div>

                                  {/** end head **/}

                                  <div
                                    className="content canves-body"
                                    style={{
                                      height: this.props.heights.body + "%",
                                    }}
                                  >
                                    <div
                                      className="canves-content-children"
                                      style={{
                                        marginLeft:
                                          this.props.properties.prop.margin ? this.props.properties.prop.margin.left *
                                            this.state.measureSpec.in : this.state.measureSpec.in +
                                          "px",
                                        marginRight:
                                          this.props.properties.prop.margin ? this.props.properties.prop.margin.right *
                                            this.state.measureSpec.in : this.state.measureSpec.in +
                                          "px",
                                        overflow: "hidden",
                                        borderTop: 0,
                                        borderBottom: 0,
                                      }}
                                    >
                                      <div
                                        style={{
                                          position: "absolute",
                                          top: 0,
                                          left: 0,
                                          right: 0,
                                          bottom: 0,
                                          marginLeft: this.props.properties.prop.margin.left + 'in',
                                          marginRight: this.props.properties.prop.margin.right + 'in'
                                        }}
                                      >
                                        {this._renderBodyElements(Object.keys(this.props.properties.items.items).map(t => this.props.properties.items.items[t]).filter(d => d && d.width !== undefined))}
                                      </div>
                                    </div>
                                    <span className="info">Body</span>
                                    <span
                                      onMouseDown={(e) =>
                                        this._slideMouseDown(e, "body")
                                      }
                                      onMouseUp={(e) => this._slideMouseUp(e)}
                                      className="slider"
                                    ></span>
                                  </div>
                                  {/** end body **/}

                                  <div
                                    className="content canves-total"
                                    style={{
                                      // height: this.props.heights.total + "%",
                                      height: '100%',
                                      backgroundColor: this.props.properties.total
                                        .background.showColor
                                        ? this.props.properties.total.background.color
                                        : "transparent",
                                    }}
                                  >
                                    <div
                                      className="canves-content-children"
                                    >
                                      <div
                                        style={{
                                          position: "absolute",
                                          top: 0,
                                          bottom: 0,
                                        }}
                                      >
                                        {this._renderElements("total")}
                                        {this._renderVatSummary()}
                                        {this._renderShapes("total")}
                                      </div>
                                    </div>
                                    <span className="info">Totals</span>
                                    <span
                                      onMouseDown={(e) =>
                                        this._slideMouseDown(e, "total")
                                      }
                                      onMouseUp={(e) => this._slideMouseUp(e)}
                                      className="slider"
                                    ></span>
                                  </div>
                                  {/** end total **/}

                                  <div
                                    className="content canves-footer"
                                    style={{
                                      // height: this.props.heights.foot + "%",
                                      height: "100%",
                                      backgroundColor: this.props.properties.foot
                                        .background.showColor
                                        ? this.props.properties.foot.background.color
                                        : "transparent",
                                    }}
                                  >
                                    <div
                                      className="canves-content-children"
                                    >
                                      <div
                                        style={{
                                          position: "absolute",
                                        }}
                                      >
                                        {this._renderElements("foot")}
                                        {this._renderShapes("foot")}
                                      </div>
                                    </div>
                                    <span className="info">Footer</span>
                                  </div>
                                </Split>
                              </div>
                              {/** end foot **/}
                            </div>
                          </div>
                        </div>
                      </div>
                    </Ruler>
                  </div>
                </div>
              </div>
              {this.state.selectedElementName !== "" && (
                <div className="editor-wrapper">
                  <div className="editor-panel bg-primary">
                    <div
                      style={{
                        maxHeight: "50vh",
                        maxWidth: "100%",
                        display: "flex",
                      }}
                    >
                      <div style={{ overflow: "auto", flex: "1 1 0%" }}>
                        <div>
                          {Object.keys(this.editIcons).map((i) => {
                            var obj = this.editIcons[i];
                            const isActive = this._getButtonActiveState(obj);
                            //console.log(i, obj);
                            return (
                              <button
                                className={`panel-react-outer panel-react-inner ${isActive ? 'active' : ''}`}
                                tabIndex="0"
                                type="button"
                                title={obj.title}
                                // onClick={(e) => {
                                //   var ele = document.getElementById(
                                //     this.state.selectedElementName
                                //   );
                                //   let section =
                                //     ele.getAttribute("data-section");
                                //   let path = ele.getAttribute("data-path");
                                //   let index = ele.getAttribute("data-index");
                                //   if (obj.isIncrement) {
                                //     const currentSize = parseInt(ele.style.fontSize) ||
                                //       parseInt(this.props.properties[section]?.font?.fontSize) ||
                                //       parseInt(this.props.properties.prop.fontSize);
                                //     const newSize = currentSize + obj.value;
                                //     ele.style[obj.property] = newSize + "px";
                                //     this.props.updateElementStyle(obj.property, newSize + "px");
                                //   } else {
                                //     ele.style[obj.property] = obj.value;
                                //     this.props.updateElementStyle(obj.property, obj.value);
                                //   }
                                // }}
                                onClick={(e) => {
                                  this._handleStyleUpdate(
                                    obj.property,
                                    obj.value,
                                    obj.isIncrement,
                                    obj.isHeading,
                                    obj.isToggle,
                                    obj.offValue,
                                    obj.isList
                                  );
                                }}
                              >
                                <i
                                  style={{
                                    fontSize: "1.3rem",
                                    color: isActive ? "#007bff" : "white"
                                  }}
                                  className={"text-white bi bi-" + obj.icon}
                                ></i>
                              </button>
                            );
                          })}
                        </div>
                      </div>
                    </div>
                    <hr />
                  </div>
                </div>
              )}
            </div>
          </div>

          {this.state.showToolTips && (
            <div
              style={{
                position: "absolute",
                top: "50px",
                bottom: 0,
                right: 0,
                transition: "right .2s ease-in-out",
                width: "450px",
                zIndex: 1000001,
                backgroundColor: "#fff",
                boxShadow: "-2px 5px 10px 1px rgb(214, 214, 214)",
              }}
            >
              <div
                className="flyout-header pagetip-header "
                style={{
                  borderBottom: "1px solid #eee",
                  top: 0,
                  left: 0,
                  right: 0,
                  position: "absolute",
                }}
              >
                <div
                  className="section notification-header"
                  style={{
                    padding: "14px 20px",
                    borderBottom: 0,
                    display: "flex",
                  }}
                >
                  <h5 className="me-auto mb-0">
                    <span
                      className="font-large align-middle"
                      style={{ margin: "12px 0px", display: "block" }}
                    >
                      Page Tips
                    </span>
                  </h5>
                  <a
                    style={{ marginTop: "10px", marginRight: "8px" }}
                    className="ms-auto text-muted"
                    onClick={(e) => {
                      this.setState({ showToolTips: false });
                    }}
                  >
                    <FontAwesomeIcon icon="times" />
                  </a>
                </div>
              </div>
              <div
                className="flyout-body sidebar-body "
                style={{
                  top: "66px",
                  bottom: 0,
                  overflowY: "scroll",
                  backgroundColor: "#FFFFFFFF",
                  paddingBottom: "50px",
                  left: 0,
                  right: 0,
                  position: "absolute",
                }}
              >
                <div id="ember2262" className="ember-view">
                  <div id="ember2263" className="ember-view"></div>
                  <div className="sub-section">
                    <div id="ember2264" className="faq-search ember-view">
                      <div className="search-field">
                        <div className="input-group btn-group ">
                          <div className="input-group-prepend">
                            <span
                              className="input-group-text"
                              style={{ height: "32px" }}
                            >
                              <FontAwesomeIcon icon="search" />
                            </span>
                          </div>
                          <input
                            placeholder="Search Help Resources"
                            id="ember2265"
                            className="form-control ember-text-field ember-view"
                            type="text"
                          />
                        </div>
                      </div>
                    </div>
                    <ul className="faq-list font-small ml-n2">
                      <div id="ember2266" className="ember-view">
                        <div className="loading text-center ">
                          <div className="load-circle1"></div>
                          <div className="load-circle2"></div>
                          <div className="load-circle3"></div>
                          <div className="load-circle4"></div>
                          <div className="load-circle5"></div>
                        </div>
                      </div>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          )}

          <div
            className="fill list-header topgrad bg-light border-top"
            style={{
              left: "60px",
              bottom: "0px",
              position: "absolute",
              zIndex: 100000002,
              width: "340px",
              padding: "12px",
            }}
          >
            <div className="list-filter d-flex">
              <InvoicePreview
                properties={this.props.properties}
                heights={this.props.heights}
              />
              <button
                className="btn btn-primary ember-view me-auto"
                type="submit"
                style={{ width: "100px" }}
                onClick={(e) => this._saveTemplate(e)}
              >
                {this.state.isSaving ? (
                  <FontAwesomeIcon
                    icon="spinner"
                    color="white"
                    className="rotate me-2"
                  />
                ) : (
                  <>Save</>
                )}
              </button>
              <button
                className="btn btn-link ms-auto"
                style={{ width: "60px" }}
                onClick={(e) => this._closeWindow(e)}
              >
                Close
              </button>
            </div>
          </div>
        </div>

        <Modal
          show={this.state.showAlert}
          onHide={(e) => {
            this.setState({ showAlert: false });
          }}
          style={{ zIndex: 10600, backgroundColor: "#484848b3" }}
        >
          <Modal.Header closeButton>
            <Modal.Title>Alert</Modal.Title>
          </Modal.Header>
          <Modal.Body>The data is modified and not saved</Modal.Body>
          <Modal.Footer>
            <Button
              variant="secondary"
              onClick={(e) => {
                this.setState({ showAlert: false }, function () {
                  this._confirmClose(e);
                });
              }}
            >
              Close Window
            </Button>
            <Button
              variant="primary"
              onClick={(e) => {
                this._saveTemplate();
              }}
            >
              Save Changes
            </Button>
          </Modal.Footer>
        </Modal>

        <Toast
          show={
            this.state.successMessage !== "" || this.state.errorMessage !== ""
          }
          onClose={() => {
            this.setState({
              successMessage: "",
              errorMessage: "",
            });
          }}
        >
          <Toast.Header
            className={
              (this.state.errorMessage === "" ? "bg-success" : "bg-danger") +
              " text-white"
            }
          >
            <strong className="me-auto">
              {this.state.errorMessage === "" ? "Hooray!" : "Oooops!!!"}
            </strong>
            <small className="pe-2">
              {formatDate(new Date(), "dddd h:mmtt d MMM yyyy")}
            </small>
          </Toast.Header>
          <Toast.Body>
            {this.state.errorMessage === "" ? (
              <>{this.state.successMessage}</>
            ) : (
              <>{this.state.errorMessage}</>
            )}
          </Toast.Body>
        </Toast>
      </>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    properties: {
      prop: state.template.prop,
      head: state.template.head,
      items: state.template.items,
      total: state.template.total,
      foot: state.template.foot
    },
    selectedElement: state.template.selectedElement,
    heights: state.template.heights,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    updateProp: (e) => dispatch(updateProp(e)),
    updateHead: (e) => dispatch(updateHead(e)),
    updateItems: (e) => dispatch(updateItems(e)),
    updateTotal: (e) => dispatch(updateTotal(e)),
    updateFoot: (e) => dispatch(updateFoot(e)),
    setSelectedElement: (section, path, index, element) =>
      dispatch(setSelectedElement(section, path, index, element)),
    moveElement: (top, left) => dispatch(moveElement(top, left)),
    resizeElement: (height, width) => dispatch(resizeElement(height, width)),
    setSectionHeight: (head, body, total, foot) =>
      dispatch(setSectionHeight(head, body, total, foot)),
    removeHeaderImage: () => dispatch(removeHeaderImage()),
    updateHeaderLogo: (logo) => dispatch(updateHeaderLogo(logo)),
    updateSplitSizes: (data) => dispatch(updateSplitSizes(data)),
    updateElementStyle: (property, value) => dispatch(updateElementStyle(property, value)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(NewTemplate);

function SaveConfirmModel(props) {
  //console.log(props);

  return props.show ? (
    <Modal
      {...props}
      style={{ zIndex: 10600, backgroundColor: "#484848b3" }}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
    >
      <Modal.Header closeButton>
        <Modal.Title id="contained-modal-title-vcenter"></Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <h4>Centered Modal</h4>
        <p>
          Cras mattis consectetur purus sit amet fermentum. Cras justo odio,
          dapibus ac facilisis in, egestas eget quam. Morbi leo risus, porta ac
          consectetur ac, vestibulum at eros.
        </p>
      </Modal.Body>
      <Modal.Footer>
        <Button onClick={props.onHide}>Close</Button>
      </Modal.Footer>
    </Modal>
  ) : (
    <></>
  );
}
